import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import Intestazione from "../../assets/intestazione-Giuvi-3.png";
import DpiImg from "../../assets/dpi.png";

// Cartelli imports
import img01 from "../../assets/cartelli/01.Fumare.png";
import img02 from "../../assets/cartelli/02.Pedoni.png";
import img03 from "../../assets/cartelli/03.SpegnereAcqua.png";
import img04 from "../../assets/cartelli/04.FiammeLibere.png";
import img05 from "../../assets/cartelli/05.NonToccare.png";
import img06 from "../../assets/cartelli/06.DivietoMuletti.png";
import img07 from "../../assets/cartelli/07.AcquaNonPotabile.png";
import img08 from "../../assets/cartelli/08.DivietoAccesso.png";
import img09 from "../../assets/cartelli/09.MaterialeInfiammabile.png";
import img10 from "../../assets/cartelli/10.SostanzeVelenose.png";
import img11 from "../../assets/cartelli/11.SostanzeCorrosive.png";
import img12 from "../../assets/cartelli/12.CarichiSospesi.png";
import img13 from "../../assets/cartelli/13.PericoloGenerico.png";
import img14 from "../../assets/cartelli/14.CadutaDislivello.png";
import img15 from "../../assets/cartelli/15.MaterialeComburente.png";
import img16 from "../../assets/cartelli/16.SostanzeNocive.png";
import img17 from "../../assets/cartelli/17.PericoloInciampo.png";
import img18 from "../../assets/cartelli/18.Occhiali.png";
import img19 from "../../assets/cartelli/19.Casco.png";
import img20 from "../../assets/cartelli/20.Cuffie.png";
import img21 from "../../assets/cartelli/21.Maschera.png";
import img22 from "../../assets/cartelli/22.Scarpe.png";
import img23 from "../../assets/cartelli/23.Guanti.png";
import img24 from "../../assets/cartelli/24.Obbligo.png";
import img25 from "../../assets/cartelli/25.Imbracatura.png";
import img26 from "../../assets/cartelli/26.Tuta.png";
import img27 from "../../assets/cartelli/27.MascheraOcchi.png";
import img28 from "../../assets/cartelli/28.Pedoni.png";
import img29 from "../../assets/cartelli/29.Uscita emergenza.png";
import img30 from "../../assets/cartelli/30.Pronto soccorso.png";
import img31 from "../../assets/cartelli/31.Estintore.png";
import img32 from "../../assets/cartelli/32.Via.png";
import img33 from "../../assets/cartelli/33.Alt.png";
import img34 from "../../assets/cartelli/34.Ferma.png";
import img35 from "../../assets/cartelli/35.Solleva.png";
import img36 from "../../assets/cartelli/36.Abbassa.png";
import img37 from "../../assets/cartelli/37.DistanzaVert.png";
import img38 from "../../assets/cartelli/38.DistanzaOriz.png";
import img39 from "../../assets/cartelli/39.Avanti.png";
import img40 from "../../assets/cartelli/40.Indietro.png";
import img41 from "../../assets/cartelli/41.Destra.png";
import img42 from "../../assets/cartelli/42.Sinistra.png";
import img43 from "../../assets/cartelli/43.Pericolo.png";

const borderColor = [161, 16, 0];

// --- Matrice di valutazione del rischio (D. Lgs. 81/08): R = P × D ---
// Calcola l'indice di rischio R = P × D (numeri interi 1-4). Restituisce null se i dati non sono validi.
export function computeIndiceRischio(probabilita, danno) {
  const p = Number(probabilita);
  const d = Number(danno);
  if (!Number.isFinite(p) || !Number.isFinite(d)) return null;
  if (p < 1 || p > 4 || d < 1 || d > 4) return null;
  return Math.round(p) * Math.round(d);
}

// Classifica l'indice di rischio secondo la matrice adottata dal POS.
export function classifyRischio(indice) {
  const i = Number(indice);
  if (!Number.isFinite(i) || i < 1) {
    return { livello: "Non valutato", color: [120, 120, 120] };
  }
  if (i <= 2) return { livello: "Trascurabile", color: [46, 125, 50] };
  if (i <= 4) return { livello: "Basso", color: [141, 180, 0] };
  if (i <= 8) return { livello: "Medio", color: [230, 145, 56] };
  return { livello: "Alto", color: [198, 40, 40] };
}

async function loadImageAsDataUrl(src) {
  return new Promise((resolve) => {
    const img = new Image();
    img.crossOrigin = "Anonymous";
    img.onload = () => {
      const maxWidth = 800;
      let width = img.width;
      let height = img.height;

      if (width > maxWidth) {
        height = (height * maxWidth) / width;
        width = maxWidth;
      }

      const canvas = document.createElement("canvas");
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext("2d");

      ctx.fillStyle = "#FFFFFF";
      ctx.fillRect(0, 0, width, height);
      ctx.drawImage(img, 0, 0, width, height);

      resolve(canvas.toDataURL("image/jpeg", 0.7));
    };
    img.onerror = () => resolve(null);
    img.src = src;
  });
}

export async function downloadPosPdf({
  posData,
  fileName,
  dataRedazione,
  dataInizio,
  indirizzoCantiere,
  durataLavori,
  preposto,
  subappaltatori,
  dittaAppaltatrici,
}) {
  const doc = new jsPDF({ unit: "mm", format: "a4", compress: true });
  doc.setFont("helvetica", "normal");
  const formattedDate = dataRedazione
    ? dataRedazione.split("-").reverse().join("/")
    : "";
  const formattedDataInizio = dataInizio
    ? dataInizio.split("-").reverse().join("/")
    : "";
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  const marginLeft = 15;
  const marginRight = 15;
  const contentWidth = pageWidth - marginLeft - marginRight;

  // Carica immagini
  const headerDataUrl = await loadImageAsDataUrl(Intestazione);

  const addHeader = (doc) => {
    if (headerDataUrl) {
      const imgWidth = 50; // Ridotto a 50mm come richiesto (simile a presenzePdf)
      doc.addImage(headerDataUrl, "JPEG", marginLeft, 10, imgWidth, 0); // Altezza 0 mantiene aspect ratio
    }
  };

  const checkPageBreak = (currentY, neededHeight) => {
    if (currentY + neededHeight > pageHeight - 20) {
      doc.addPage();
      addHeader(doc);
      return 45; // New Y start after header
    }
    return currentY;
  };

  // --- Pagina 1: Frontespizio ---
  addHeader(doc);
  let y = 45;

  doc.setFontSize(22);
  doc.setTextColor(borderColor[0], borderColor[1], borderColor[2]);
  doc.text("PIANO OPERATIVO DI SICUREZZA", pageWidth / 2, y, {
    align: "center",
  });
  doc.setFontSize(14);
  doc.text(
    "(Art. 89, comma 1, lettera h, D.Lgs. 81/08)",
    pageWidth / 2,
    y + 8,
    { align: "center" },
  );

  y += 20;
  doc.setTextColor(0);
  doc.setFontSize(12);

  const frontespizio = posData.Frontespizio || {};
  const frontespizioCantiere = frontespizio.Cantiere || "";
  const frontespizioIndirizzo =
    frontespizio.IndirizzoCantiere ||
    frontespizio.Indirizzo ||
    indirizzoCantiere ||
    "";
  const frontespizioData = [
    ["Committente", frontespizio.Committente || ""],
    ["Impresa Esecutrice", "Giuvi S.r.l."],
    ["Cantiere", frontespizioCantiere],
    ["Indirizzo Cantiere", frontespizioIndirizzo],
    ["Descrizione Opere", frontespizio.DescrizioneOpere || ""],
    ["Data", frontespizio.Data || new Date().toLocaleDateString()],
    ["Revisione", frontespizio.Revisione || "00"],
  ];

  const bottomMargin = 20;
  const signatureTableHeightEstimate = 38;
  const signatureLabelGap = 6;
  const signatureLabelY =
    pageHeight -
    bottomMargin -
    signatureTableHeightEstimate -
    signatureLabelGap;
  const signatureTableY = signatureLabelY + signatureLabelGap;
  const reservedBottom = pageHeight - (signatureLabelY - 6);

  const firstPageNumber = 1;

  autoTable(doc, {
    startY: y,
    head: [],
    body: frontespizioData,
    theme: "plain",
    rowPageBreak: "avoid",
    styles: { fontSize: 12, cellPadding: 3 },
    margin: { left: marginLeft, right: marginRight, bottom: reservedBottom },
    columnStyles: {
      0: { fontStyle: "bold", width: 50 },
      1: { width: "auto" },
    },
    didDrawPage: (data) => {
      addHeader(doc);
      if (data.pageNumber === 1) return;
    },
  });

  // Tabella Firme (4x1)
  const lastFrontespizioPage = doc.internal.getNumberOfPages();
  doc.setPage(firstPageNumber);
  y = signatureLabelY;

  doc.setFontSize(12);
  doc.setTextColor(borderColor[0], borderColor[1], borderColor[2]);
  doc.text("Firme per accettazione e presa visione:", marginLeft, y);
  y = signatureTableY;

  const colWidth = contentWidth / 4;

  autoTable(doc, {
    startY: y,
    head: [["Datore di Lavoro", "RSPP", "RLS", "Medico Competente"]],
    body: [
      [
        { content: " ", styles: { minCellHeight: 20 } },
        { content: " ", styles: { minCellHeight: 20 } },
        { content: " ", styles: { minCellHeight: 20 } },
        { content: " ", styles: { minCellHeight: 20 } },
      ],
      [
        `Data: ${formattedDate}`,
        `Data: ${formattedDate}`,
        `Data: ${formattedDate}`,
        `Data: ${formattedDate}`,
      ],
    ],
    theme: "grid",
    styles: {
      halign: "center",
      valign: "middle",
      cellPadding: 2,
    },
    headStyles: {
      fillColor: borderColor,
      textColor: 255,
      halign: "center",
      minCellHeight: 8,
    },
    columnStyles: {
      0: { cellWidth: colWidth },
      1: { cellWidth: colWidth },
      2: { cellWidth: colWidth },
      3: { cellWidth: colWidth },
    },
    tableWidth: "wrap",
  });

  // --- Pagina 2: Dati da Documentazione di Cantiere ---
  doc.setPage(lastFrontespizioPage);
  doc.addPage();
  addHeader(doc);
  y = 45;
  doc.setFontSize(16);
  doc.setTextColor(borderColor[0], borderColor[1], borderColor[2]);
  doc.text("Figure per Responsabili per la Sicurezza", marginLeft, y);
  y += 15;

  const figure = posData.FigureSicurezza || [];
  const entries = Array.isArray(figure) ? figure : [];

  if (entries.length > 0) {
    entries.forEach((figura) => {
      // Stima altezza blocco:
      // Titolo (Qualifica): 7
      // Nome Cognome: 6
      // Indirizzo: 6
      // CAP Città: 6
      // Margine inf: 8
      // Totale approx: 33
      const neededHeight = 35;
      y = checkPageBreak(y, neededHeight);

      // 1. Qualifica (Titolo Rosso)
      doc.setFontSize(12);
      doc.setFont("helvetica", "bold");
      doc.setTextColor(borderColor[0], borderColor[1], borderColor[2]);
      doc.text(figura.qualifica || "Ruolo non specificato", marginLeft, y);
      y += 6;

      // 2. Nome e Cognome (Grassetto Nero)
      doc.setFontSize(11);
      doc.setFont("helvetica", "bold");
      doc.setTextColor(0);
      doc.text(figura.nomeCognome || "Nome non disponibile", marginLeft, y);
      y += 6;

      // 3. Indirizzo (Normale)
      doc.setFont("helvetica", "normal");
      doc.text(figura.indirizzo || "Indirizzo N.D.", marginLeft, y);
      y += 6;

      // 4. CAP e Città (Normale)
      const capCitta = `${figura.cap || ""} ${figura.citta || ""}`.trim();
      doc.text(capCitta || "Città N.D.", marginLeft, y);
      y += 10; // Spazio extra tra figure
    });
  } else {
    doc.setFontSize(12);
    doc.setTextColor(0);
    doc.text(
      "Nessun dato estratto dall'immagine o disponibile.",
      marginLeft,
      y,
    );
  }

  // --- Pagina 3: Anagrafica Aziendale ---
  doc.addPage();
  addHeader(doc);
  y = 45;
  doc.setFontSize(16);
  doc.setTextColor(borderColor[0], borderColor[1], borderColor[2]);
  const titoloPreposto =
    "Personale preposto alla sicurezza nei luoghi di lavoro ai sensi del D.Lgs. 81/08";
  const splitTitoloPreposto = doc.splitTextToSize(titoloPreposto, contentWidth);
  doc.text(splitTitoloPreposto, marginLeft, y);
  y += splitTitoloPreposto.length * 7 + 3; // Adjusted for font size 16

  // Placeholder testo PRE tabella
  doc.setFontSize(11);
  doc.setTextColor(0);
  const testoPreTabella =
    "CON LA PRESENTE SI DICHIARA di aver redatto il documento di valutazione dei rischi previsto di cui all’art. 28 del D. Lgs 81/08 dal quale risulta che:";
  const splitPre = doc.splitTextToSize(testoPreTabella, contentWidth);
  doc.text(splitPre, marginLeft, y);
  y += splitPre.length * 5 + 5;

  const anagraficaSource = posData.AnagraficaAziendale || {};

  // Default values hardcoded
  const defaults = {
    "Ragione Sociale": "GIUVI S.R.L.",
    "Partita IVA": "07873720960",
    "Sede Legale": "Via Belgirate, 15 - 20125 Milano (MI)",
    Email: "info@giuvi.it",
    Telefono: "02/97190315",
  };

  const nestedAnagraficaSources = [anagraficaSource];
  Object.entries(anagraficaSource).forEach(([key, value]) => {
    if (
      value &&
      typeof value === "object" &&
      !Array.isArray(value) &&
      /impresa|referenti?|aziendal/i.test(key)
    ) {
      nestedAnagraficaSources.push(value);
    }
  });

  const valueToCellString = (value) => {
    if (value == null) return "";
    if (
      typeof value === "string" ||
      typeof value === "number" ||
      typeof value === "boolean"
    ) {
      return String(value).trim();
    }
    if (Array.isArray(value)) {
      return value
        .map((item) => {
          if (
            typeof item === "string" ||
            typeof item === "number" ||
            typeof item === "boolean"
          ) {
            return String(item).trim();
          }
          return "";
        })
        .filter(Boolean)
        .join("\n");
    }
    return "";
  };

  const findMappedValue = (patterns, excludePattern) => {
    for (const source of nestedAnagraficaSources) {
      for (const [key, value] of Object.entries(source)) {
        if (excludePattern?.test(key)) continue;
        if (!patterns.some((pattern) => pattern.test(key))) continue;

        const textValue = valueToCellString(value);
        if (!textValue || textValue.toUpperCase() === "N.D.") continue;

        return { key, value: textValue };
      }
    }
    return null;
  };

  const keyMappings = [
    {
      target: "Ragione Sociale",
      patterns: [/ragione\s*sociale/i, /denominazione/i],
    },
    { target: "Partita IVA", patterns: [/p\.?iva/i, /partita\s*iva/i] },
    {
      target: "Sede Legale",
      patterns: [/sede/i, /indirizzo\s*(sede|legale|azienda)/i],
    },
    { target: "Email", patterns: [/e-?mail/i, /posta\s*elettronica/i] },
    { target: "Telefono", patterns: [/telefo?n?o?/i, /cellulare/i] },
    {
      target: "Datore di Lavoro",
      patterns: [/datore\s*(di)?\s*lavoro/i],
    },
    { target: "RSPP", patterns: [/rspp/i] },
    { target: "RLS", patterns: [/rls/i] },
    {
      target: "Medico Competente",
      patterns: [/medico\s*competente/i],
    },
    {
      target: "Addetto Primo Soccorso",
      patterns: [/addetto\s*primo\s*soccorso/i, /primo\s*soccorso/i],
    },
    {
      target: "Addetto Antincendio",
      patterns: [/addetto\s*antincendio/i, /antincendio/i],
    },
    {
      target: "Addetto Evacuazione",
      patterns: [/addetto\s*evacuazione/i, /evacuazione/i],
    },
    { target: "Preposto", patterns: [/preposto/i] },
  ];

  const finalAnagraficaRows = [];
  const usedKeys = new Set();

  keyMappings.forEach(({ target, patterns }) => {
    const match = findMappedValue(
      patterns,
      /rspp|datore|medico|rls|addetto|preposto/i.test(target)
        ? null
        : /rspp|datore|medico|rls|addetto|preposto/i,
    );

    if (match?.key) {
      usedKeys.add(match.key);
    }

    const resolvedValue = match?.value || defaults[target] || "";
    if (resolvedValue) {
      finalAnagraficaRows.push([target, resolvedValue]);
    }
  });

  nestedAnagraficaSources.forEach((source) => {
    Object.entries(source).forEach(([key, value]) => {
      if (usedKeys.has(key)) return;
      if (/^impresa$|^referenti?\s*aziendali$/i.test(key)) return;

      const textValue = valueToCellString(value);
      if (!textValue || textValue.toUpperCase() === "N.D.") return;

      finalAnagraficaRows.push([key, textValue]);
      usedKeys.add(key);
    });
  });

  const seenRows = new Set();
  const anagraficaRows = finalAnagraficaRows.filter(([key, value]) => {
    const signature = `${String(key).trim().toLowerCase()}::${String(value).trim().toLowerCase()}`;
    if (seenRows.has(signature)) {
      return false;
    }
    seenRows.add(signature);
    return true;
  });

  autoTable(doc, {
    startY: y,
    body: anagraficaRows,
    theme: "striped",
    rowPageBreak: "avoid",
    showHead: "never",
    columnStyles: { 0: { fontStyle: "bold", width: 60 } },
  });

  // Placeholder testo POST tabella
  y = doc.lastAutoTable.finalY + 10;

  const testoPostTabellaParte1 =
    "Si è assicurata ad ogni figura coinvolta nell’attività la formazione ed informazione sulla tipologia dei lavori da eseguire e sui contenuti e le disposizioni del presente piano.";

  const testoPostTabellaParte2 =
    "Il personale dell’Amministrazione collabora alla gestione delle manutenzioni, con riferimento sia alle verifiche periodiche obbligatorie sia ai programmi o attività stabiliti internamente, alla gestione degli eventuali rapporti con gli enti di vigilanza (ASL, VV.F., ISPESL, ARPA etc.), alla gestione dei programmi di formazione, alla gestione, al ritiro e alla distribuzione dei Dispositivi di Protezione Individuale (DPI), alla gestione dei rapporti con il Medico Competente, alla tenuta del registro infortuni e alla gestione dei rapporti con INAIL ed altri enti.";

  // Parte 1
  const splitPost1 = doc.splitTextToSize(testoPostTabellaParte1, contentWidth);
  if (y + splitPost1.length * 5 > pageHeight - 20) {
    doc.addPage();
    addHeader(doc);
    y = 45;
  }
  doc.text(splitPost1, marginLeft, y);

  // Spazio tra le due sezioni
  y += splitPost1.length * 5 + 10;

  // Parte 2
  const splitPost2 = doc.splitTextToSize(testoPostTabellaParte2, contentWidth);
  if (y + splitPost2.length * 5 > pageHeight - 20) {
    doc.addPage();
    addHeader(doc);
    y = 45;
  }
  doc.text(splitPost2, marginLeft, y);

  // --- Pagina 4: Anagrafica Impresa Esecutrice ---
  doc.addPage();
  addHeader(doc);
  y = 45;
  doc.setFontSize(16);
  doc.setTextColor(borderColor[0], borderColor[1], borderColor[2]);
  doc.text("ANAGRAFICA E IDONEITA’", marginLeft, y);
  y += 7;
  doc.text("PROFESSIONALE DELL’IMPRESA ESECUTRICE", marginLeft, y);
  y += 15;

  const anagraficaImpresaData = [
    ["Ragione Sociale", "GIUVI S.r.l."],
    ["Indirizzo Sede Legale", "Via Belgirate, 15 - 20125 Milano (MI)"],
    ["Titolare/Legale Rappresentante", "Roberto Ferri"],
    ["Iscrizione registro imp. Art. n°", "07873720960"],
    ["Iscrizione C.C.I.A.A.", "REA MI-2010873"],
    ["Settore Merceologico", "Impiantistica"],
    ["Anno di inizio Attività", "2012"],
    ["Telefono", "Tel. 02/97190315"],
    ["Email / PEC", "info@giuvi.it, giuvisrl@lamiapec.it"],
    ["CCNL Applicato", "Artigianato Metalmeccanico"],
  ];

  autoTable(doc, {
    startY: y,
    body: anagraficaImpresaData,
    theme: "grid",
    styles: {
      cellPadding: 3,
      fontSize: 11,
      valign: "middle",
    },
    columnStyles: {
      0: { fontStyle: "bold", width: 60, fillColor: [240, 240, 240] },
      1: { width: "auto" },
    },
  });

  y = doc.lastAutoTable.finalY + 10;

  doc.setFontSize(11);
  doc.setTextColor(0);
  const testoAggiuntivo =
    "L’azienda provvede con il presente documento all’adempimento della predisposizione del Piano Operativo di Sicurezza. Il documento di valutazione dei rischi è stato redatto dal Datore di Lavoro e contiene l’impegno nell’adottare tutti i provvedimenti per salvaguardare la salute e la sicurezza dei lavoratori. Si e’ provveduto alla nomina del medico competente per l’attuazione della sorveglianza sanitaria dei lavoratori e ha predisposto un adeguato programma di sorveglianza Allo scopo di salvaguardare l'incolumità dei lavoratori e di garantirne le migliori condizioni di soccorso possibili qualora occorrenti, si provvede a fornire agli addetti alle attività di cantiere le necessarie informazioni generali di comportamento durante le emergenze. Comunque per la gestione delle emergenze ci si attiene alle indicazioni fornite dalla committenza";
  const splitAggiuntivo = doc.splitTextToSize(testoAggiuntivo, contentWidth);
  doc.text(splitAggiuntivo, marginLeft, y);
  y += splitAggiuntivo.length * 5 + 5;

  doc.setFontSize(11);
  doc.setTextColor(0);
  const testoIdoneita =
    "Il sottoscritto, in qualità di Datore di Lavoro dell'Impresa Esecutrice, DICHIARA sotto la propria responsabilità di essere in possesso dei requisiti di idoneità tecnico-professionale previsti dall'art. 26 comma 1 lett. a) punto 2 del D.Lgs. 81/08 e s.m.i. e dell'Allegato XVII dello stesso decreto. Dichiara inoltre di applicare il CCNL indicato e di essere in regola con gli obblighi contributivi e assicurativi.";

  const splitIdoneita = doc.splitTextToSize(testoIdoneita, contentWidth);
  doc.text(splitIdoneita, marginLeft, y);

  // --- Pagina 5: Personale e Turni ---
  doc.addPage();
  addHeader(doc);
  y = 45;
  doc.setFontSize(16);
  doc.setTextColor(borderColor[0], borderColor[1], borderColor[2]);
  doc.text("Personale e Turni", marginLeft, y);
  y += 10;

  const personale = posData.PersonaleTurni || [];
  if (typeof personale === "string") {
    doc.setFontSize(11);
    doc.setTextColor(0);
    const splitText = doc.splitTextToSize(personale, contentWidth);
    doc.text(splitText, marginLeft, y);
    y += splitText.length * 5 + 10;
  } else if (Array.isArray(personale)) {
    const headers = ["Nome", "Mansione", "Turni", "Prescrizioni specifiche"];
    const body = personale.map((p) => {
      if (!p || typeof p !== "object") {
        return [String(p ?? ""), "", "", ""];
      }
      return [
        p.Nome ?? "",
        p.Mansione ?? "",
        p.Turni ?? "",
        p.Prescrizioni ?? "",
      ];
    });
    autoTable(doc, {
      startY: y,
      head: [headers],
      body: body,
      theme: "grid",
      headStyles: { fillColor: borderColor, textColor: 255, fontStyle: "bold" },
      styles: { fontSize: 9, cellPadding: 3, valign: "top" },
      columnStyles: {
        0: { cellWidth: 40 },
        1: { cellWidth: 38 },
        2: { cellWidth: 42 },
        3: { cellWidth: "auto" },
      },
      margin: { left: marginLeft, right: marginRight, bottom: 25 },
    });
    y = doc.lastAutoTable.finalY + 10;
  } else {
    const rows = Object.entries(personale).map(([k, v]) => [k, v]);
    autoTable(doc, { startY: y, body: rows, rowPageBreak: "avoid" });
    y = doc.lastAutoTable.finalY + 10;
  }

  // --- Posizioni Contributive ---
  doc.setFontSize(14);
  doc.setTextColor(borderColor[0], borderColor[1], borderColor[2]);
  doc.text("Posizioni Contributive", marginLeft, y);
  y += 5;

  const posizioniContributiveData = [
    ["Posizione INAIL", "PAT 19083034/46 - Sede di Milano Sabaudia"],
    ["Posizione INPS", "PA 4978037989 - Sede di Milano Est"],
    ["Posizione Cassa Edile", "42149 - Sede di Milano, Lodi, Monza e Brianza"],
    [
      "Polizza assicurativa RCT o RCO",
      "Groupama Assicurazioni - POLIZZA RCT 1103421",
    ],
  ];

  autoTable(doc, {
    startY: y,
    body: posizioniContributiveData,
    theme: "grid",
    styles: { cellPadding: 3, fontSize: 11, valign: "middle" },
    columnStyles: {
      0: { fontStyle: "bold", width: 60, fillColor: [240, 240, 240] },
      1: { width: "auto" },
    },
  });

  // --- Pagina 6: Notifica Adempimenti ---
  doc.addPage();
  addHeader(doc);
  y = 45;
  doc.setFontSize(16);
  doc.setTextColor(borderColor[0], borderColor[1], borderColor[2]);
  doc.text("NOTIFICA ADEMPIMENTI RELATIVI ALLA SICUREZZA", marginLeft, y);
  y += 10;

  // Dati Azienda
  const datiAziendaNotifica = [
    ["Ragione Sociale", "GIUVI S.r.l."],
    ["Indirizzo", "Via Belgirate, 15 - 20125 Milano (MI)"],
  ];

  doc.setFontSize(12);
  doc.setTextColor(0);
  doc.text("Dati Azienda", marginLeft, y);
  y += 5;

  autoTable(doc, {
    startY: y,
    body: datiAziendaNotifica,
    theme: "grid",
    styles: { cellPadding: 3, fontSize: 11, valign: "middle" },
    columnStyles: {
      0: { fontStyle: "bold", width: 60, fillColor: [240, 240, 240] },
      1: { width: "auto" },
    },
  });
  y = doc.lastAutoTable.finalY + 10;

  // Descrizione Lavori
  const descrizioneLavoriNotifica = [
    ["Oggetto dei lavori", frontespizio.DescrizioneOpere || ""],
  ];

  doc.text("Descrizione Lavori", marginLeft, y);
  y += 5;

  autoTable(doc, {
    startY: y,
    body: descrizioneLavoriNotifica,
    theme: "grid",
    styles: { cellPadding: 3, fontSize: 11, valign: "middle" },
    columnStyles: {
      0: { fontStyle: "bold", width: 60, fillColor: [240, 240, 240] },
      1: { width: "auto" },
    },
  });
  y = doc.lastAutoTable.finalY + 10;

  // Ubicazione Cantiere
  const ubicazioneCantiereNotifica = [
    ["Cantiere", frontespizioCantiere || ""],
    ["Indirizzo Cantiere", frontespizioIndirizzo || ""],
  ];

  doc.text("Ubicazione Cantiere", marginLeft, y);
  y += 5;

  autoTable(doc, {
    startY: y,
    body: ubicazioneCantiereNotifica,
    theme: "grid",
    styles: { cellPadding: 3, fontSize: 11, valign: "middle" },
    columnStyles: {
      0: { fontStyle: "bold", width: 60, fillColor: [240, 240, 240] },
      1: { width: "auto" },
    },
  });
  y = doc.lastAutoTable.finalY + 10;

  // Sezione Testo
  const testoNotifica =
    "Informazione, formazione e addestramento\n" +
    "Secondo quanto previsto dal D.lgs. 81/08 art.36, si provvede a fornire ai lavoratori informazioni riguardo:\n" +
    "a) i rischi per la sicurezza e la salute connessi all'attività dell'impresa in generale;\n" +
    "b) le procedure che riguardano il pronto soccorso, la lotta antincendio, l'evacuazione dei lavoratori;\n" +
    "c) i nominativi dei lavoratori appartenenti alla squadra antincendio e di primo soccorso.\n" +
    "d) il responsabile del servizio di prevenzione e protezione ed il medico competente;\n" +
    "e) i rischi specifici cui sono esposti in relazione all'attività svolta, le normative di sicurezza e le disposizioni aziendali in materia;\n" +
    "f) i pericoli connessi all'uso delle sostanze e dei preparati pericolosi sulla base delle schede dei dati di sicurezza previste dalla normativa vigente e dalle norme di buona tecnica;\n" +
    "g) le misure e le attività di protezione e prevenzione adottate;\n\n" +
    "Inoltre si provvederà a fornire specifica informazione e formazione su:\n" +
    "a) corrette modalità per la movimentazione dei carichi;\n" +
    "b) corrette modalità di utilizzo di macchine e attrezzature;\n" +
    "c) utilizzo di piattaforme elevabili";
  const splitTestoNotifica = doc.splitTextToSize(testoNotifica, contentWidth);
  const testoNotificaHeight = splitTestoNotifica.length * 5 + 5;
  y = checkPageBreak(y, testoNotificaHeight);
  doc.text(splitTestoNotifica, marginLeft, y);

  // --- Pagina 6: Ubicazione e Natura Opera ---
  doc.addPage();
  addHeader(doc);
  y = 45;
  doc.setFontSize(16);
  doc.setTextColor(borderColor[0], borderColor[1], borderColor[2]);
  doc.text("Ubicazione e Natura dell'Opera", marginLeft, y);
  y += 10;

  const ubicazioneTableData = [
    ["Ubicazione Cantiere", frontespizioCantiere || ""],
    ["Indirizzo Cantiere", frontespizioIndirizzo || ""],
    ["Natura dell'Opera", frontespizio.DescrizioneOpere || ""],
    ["Data Inizio Lavori", formattedDataInizio || ""],
    ["Durata Prevista", durataLavori || ""],
  ];

  const ubicazione = posData.UbicazioneNaturaOpera || {};
  if (typeof ubicazione === "object") {
    Object.entries(ubicazione).forEach(([k, v]) => {
      const key = k.toLowerCase();
      if (
        !key.includes("indirizzo") &&
        !key.includes("cantiere") &&
        !key.includes("descrizione") &&
        !key.includes("periodo") &&
        !key.includes("durata")
      ) {
        ubicazioneTableData.push([k, v]);
      }
    });
  }

  autoTable(doc, {
    startY: y,
    body: ubicazioneTableData,
    theme: "grid",
    styles: { cellPadding: 3, fontSize: 11, valign: "middle" },
    columnStyles: {
      0: { fontStyle: "bold", width: 60, fillColor: [240, 240, 240] },
      1: { width: "auto" },
    },
  });

  y = doc.lastAutoTable.finalY + 10;

  if (typeof ubicazione === "string" && ubicazione.trim() !== "") {
    doc.setFontSize(11);
    doc.setTextColor(0);
    const splitUbicazione = doc.splitTextToSize(ubicazione, contentWidth);
    doc.text(splitUbicazione, marginLeft, y);
    y += splitUbicazione.length * 5 + 10;
  }

  // Nuova sezione: Breve Descrizione Lavori (AI) + Testo Fisso in Box
  const breveDescrizione = posData.BreveDescrizioneLavori || "";
  const testoFisso =
    "il tutto verrà eseguito a regola dell’arte come previsto dall’ Allegato I di cui all’art. 7 del Decreto 22.01.2008 n.37. Le opere avverranno all’interno dei locali indicati nella planimetria fornita dal committente senza la presenza di persone, o fuori dagli orari di lavoro. Durante i lavori verranno apposti all’esterno dell’ufficio/locale il divieto di accesso. Gli addetti saranno dotati dei dispositivi di protezione individuale (casco, guanti, scarpe di sicurezza) della quale dichiarano di aver ricevuto idonea formazione e informazione sul suo uso e la sua manutenzione. All’esterno essi dovranno scrupolosamente percorrere solo eventuali percorsi protetti da rischio di interferenza con altre lavorazioni o lavorare in zone in cui non sussistano altre lavorazioni o pericoli accidentali (caduta materiale dall’alto, folgorazione, ustioni). Si avvarranno nel caso di scale o tra battelli a norma di legge, adeguatamente bloccate, conformi a quanto indicato nel PSC In attuazione del D. Lgs. 81/08 e norme collegate";

  const testoCompleto =
    (breveDescrizione ? breveDescrizione + "\n\n" : "") + testoFisso;

  doc.setFontSize(11);
  doc.setTextColor(0);

  // Calcolo dimensioni Box
  const boxPadding = 5;
  const boxWidth = contentWidth;
  const textWidth = boxWidth - boxPadding * 2;
  const splitTestoCompleto = doc.splitTextToSize(testoCompleto, textWidth);
  const textHeight = splitTestoCompleto.length * 5;
  const titleHeight = 10;
  const boxHeight = titleHeight + textHeight + boxPadding * 2;

  // Controllo page break per Box + Tabella Preposto
  if (y + boxHeight + 40 > pageHeight - 20) {
    doc.addPage();
    addHeader(doc);
    y = 45;
  }

  // Disegna Box
  doc.setDrawColor(0);
  doc.rect(marginLeft, y, boxWidth, boxHeight);

  // Titolo Box
  doc.setFont("helvetica", "bold");
  doc.text(
    "Valutazione dei Rischi",
    marginLeft + boxPadding,
    y + boxPadding + 5,
  );

  // Testo Box
  doc.setFont("helvetica", "normal");
  doc.text(
    splitTestoCompleto,
    marginLeft + boxPadding,
    y + boxPadding + titleHeight,
  );

  y += boxHeight + 10;

  // Tabella Preposto
  const prepostoData = [["Preposto", preposto || ""]];

  autoTable(doc, {
    startY: y,
    body: prepostoData,
    theme: "grid",
    styles: { cellPadding: 3, fontSize: 11, valign: "middle" },
    columnStyles: {
      0: { fontStyle: "bold", width: 60, fillColor: [240, 240, 240] },
      1: { width: "auto" },
    },
  });

  // --- Pagina 7: Documentazione Cantiere ---
  doc.addPage();
  addHeader(doc);
  y = 45;
  doc.setFontSize(16);
  doc.setTextColor(borderColor[0], borderColor[1], borderColor[2]);
  doc.text("Documentazione Cantiere", marginLeft, y);
  y += 10;

  // Tabella Documentazione
  const documentazioneData = [
    ["Impresa Esecutrice", "Giuvi S.r.l."],
    ["Descrizione Lavori", frontespizio.DescrizioneOpere || ""],
    [
      "Identificativo Cantiere",
      `${frontespizio.Committente || ""} - ${frontespizioIndirizzo || ""}`,
    ],
  ];

  autoTable(doc, {
    startY: y,
    body: documentazioneData,
    theme: "grid",
    styles: { cellPadding: 3, fontSize: 11, valign: "middle" },
    columnStyles: {
      0: { fontStyle: "bold", width: 60, fillColor: [240, 240, 240] },
      1: { width: "auto" },
    },
  });

  y = doc.lastAutoTable.finalY + 10;

  // Box Testo Gestione Contratti
  const testoContrattiTitle = "GESTIONE CONTRATTI D’APPALTO E D’OPERA";
  const testoContrattiBody =
    "Secondo quanto previsto dall’art.26 del D.lgs. 81/08, il datore di lavoro, nella sua funzione di committente, verifica l’idoneità tecnico-professionale della ditta appaltatrice o prestatrice d'opera tramite l’acquisizione del certificato di iscrizione alla camera di commercio, industria e artigianato e la verifica che l’attività esercitata da questo sia congruente con l’appalto o l’opera affidata.\n" +
    "Può anche richiedere la compilazione di una specifica autocertificazione da parte del rappresentante legale della ditta appaltatrice o da parte del prestatore d'opera.\n" +
    "Inoltre, il datore di lavoro fornisce al soggetto appaltatore le informazioni relative ai fattori di rischio presenti, in maniera effettiva o potenziale, nello specifico ambiente di lavoro dove si svolgeranno i lavori.\n" +
    "Il datore di lavoro, nella sua funzione di committente, redige il Documento Unico di Valutazione dei Rischi di Interferenza e promuove il coordinamento in materia di sicurezza con la ditta appaltatrice o il prestatore d'opera, cooperando col servizio di prevenzione e protezione e con la ditta appaltatrice per:\n" +
    "- l’individuazione e l'attuazione delle misure di prevenzione e protezione dai rischi sul lavoro incidenti sull'attività lavorativa oggetto dell'appalto;\n" +
    "- coordinare gli interventi di protezione e prevenzione dei rischi cui sono esposti i lavoratori, attraverso l'informazione reciproca anche al fine di eliminare i rischi dovuti alle interferenze tra i lavoratori delle diverse imprese coinvolte nell'esecuzione dell'opera complessiva.\n" +
    "Per rendere effettiva la cooperazione all'attuazione delle misure di prevenzione e protezione dai rischi, un responsabile dell’impresa appaltatrice visita periodicamente i luoghi in cui è svolto il contratto d'appalto o d'opera.";

  // Calcolo dimensioni Box
  const boxPaddingContratti = 5;
  const boxWidthContratti = contentWidth;
  const textWidthContratti = boxWidthContratti - boxPaddingContratti * 2;

  // Imposta font size per il calcolo corretto del wrapping
  doc.setFontSize(11);
  const splitTestoContratti = doc.splitTextToSize(
    testoContrattiBody,
    textWidthContratti,
  );
  const textHeightContratti = splitTestoContratti.length * 5;
  const titleHeightContratti = 10;
  const boxHeightContratti =
    titleHeightContratti + textHeightContratti + boxPaddingContratti * 2;

  // Controllo page break
  if (y + boxHeightContratti > pageHeight - 20) {
    doc.addPage();
    addHeader(doc);
    y = 45;
  }

  // Disegna Box
  doc.setDrawColor(0);
  doc.rect(marginLeft, y, boxWidthContratti, boxHeightContratti);

  // Titolo Box
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.setTextColor(borderColor[0], borderColor[1], borderColor[2]);
  doc.text(
    testoContrattiTitle,
    marginLeft + boxPaddingContratti,
    y + boxPaddingContratti + 5,
  );

  // Testo Box
  doc.setFont("helvetica", "normal");
  doc.setFontSize(11);
  doc.setTextColor(0);
  doc.text(
    splitTestoContratti,
    marginLeft + boxPaddingContratti,
    y + boxPaddingContratti + titleHeightContratti,
  );

  y += boxHeightContratti + 10;

  // --- Pagina 8: Generalità Imprese Lavoratrici ---
  doc.addPage();
  addHeader(doc);
  y = 45;
  doc.setFontSize(16);
  doc.setTextColor(borderColor[0], borderColor[1], borderColor[2]);
  doc.text("Generalità Imprese Lavoratrici", marginLeft, y);
  y += 10;

  // Tabella Impresa Appaltatrice (opzionale)
  const appaltatrice = Array.isArray(dittaAppaltatrici)
    ? dittaAppaltatrici[0]
    : null;

  if (appaltatrice) {
    doc.setFontSize(12);
    doc.setTextColor(0);
    doc.text("Impresa Appaltatrice", marginLeft, y);
    y += 5;

    const appaltatriceData = [
      ["Ragione Sociale", appaltatrice.ragioneSociale || ""],
      ["Indirizzo", appaltatrice.indirizzo || ""],
      ["P.IVA / C.F.", appaltatrice.piva || ""],
      ["Telefono", appaltatrice.telefono || ""],
      ["Email", appaltatrice.email || ""],
      ["Legale Rappresentante", appaltatrice.rappresentante || ""],
    ];

    autoTable(doc, {
      startY: y,
      body: appaltatriceData,
      theme: "grid",
      styles: { cellPadding: 3, fontSize: 11, valign: "middle" },
      columnStyles: {
        0: { fontStyle: "bold", width: 60, fillColor: [240, 240, 240] },
        1: { width: "auto" },
      },
    });

    y = doc.lastAutoTable.finalY + 10;
  }

  // Tabella Giuvi
  doc.setFontSize(12);
  doc.setTextColor(0);
  doc.text("Impresa Esecutrice", marginLeft, y);
  y += 5;

  autoTable(doc, {
    startY: y,
    body: anagraficaImpresaData,
    theme: "grid",
    styles: { cellPadding: 3, fontSize: 11, valign: "middle" },
    columnStyles: {
      0: { fontStyle: "bold", width: 60, fillColor: [240, 240, 240] },
      1: { width: "auto" },
    },
  });

  y = doc.lastAutoTable.finalY + 10;

  // Interruzione di pagina prima dei subappaltatori
  doc.addPage();
  addHeader(doc);
  y = 45;

  // Tabelle Subappaltatori
  if (Array.isArray(subappaltatori) && subappaltatori.length > 0) {
    subappaltatori.forEach((sub, index) => {
      if (index > 0 && index % 2 === 0) {
        doc.addPage();
        addHeader(doc);
        y = 45;
      }

      doc.setFontSize(12);
      doc.setTextColor(0);
      doc.text(`Impresa Subappaltatrice ${index + 1}`, marginLeft, y);
      y += 5;

      const subData = [
        ["Ragione Sociale", sub.ragioneSociale || ""],
        ["Indirizzo", sub.indirizzo || ""],
        ["P.IVA / C.F.", sub.piva || ""],
        ["Telefono", sub.telefono || ""],
        ["Email", sub.email || ""],
        ["Legale Rappresentante", sub.rappresentante || ""],
        ["Opere Assegnate", sub.opereAssegnate || sub.ccnl || ""],
      ];

      autoTable(doc, {
        startY: y,
        body: subData,
        theme: "grid",
        styles: { cellPadding: 3, fontSize: 11, valign: "middle" },
        columnStyles: {
          0: { fontStyle: "bold", width: 60, fillColor: [240, 240, 240] },
          1: { width: "auto" },
        },
      });

      y = doc.lastAutoTable.finalY + 10;
    });
  }

  // --- Pagina 9: Segnaletica di Sicurezza (Dettagliata) ---
  doc.addPage();
  addHeader(doc);
  y = 45;
  doc.setFontSize(16);
  doc.setTextColor(borderColor[0], borderColor[1], borderColor[2]);
  doc.text("Segnaletica di Sicurezza", marginLeft, y);
  y += 10;

  const safetySigns = [
    {
      isHeader: true,
      title:
        "Segnali di divieto: Vietano un comportamento dal quale potrebbe risultare un pericolo.",
    },
    { img: img01, desc: "Vietato fumare" },
    { img: img02, desc: "Vietato ai pedoni" },
    { img: img03, desc: "Divieto di spegnere con acqua" },
    { img: img04, desc: "Vietato fumare o usare fiamme libere" },
    { img: img05, desc: "Non toccare" },
    { img: img06, desc: "Vietato ai carrelli di movimentazione" },
    { img: img07, desc: "Acqua non potabile" },
    { img: img08, desc: "Divieto di accesso alle persone non autorizzate" },
    {
      isHeader: true,
      title:
        "Segnali di Pericolo: Trasmettono ulteriori informazioni sulla natura del pericolo.",
    },
    { img: img09, desc: "Materiale infiammabile o alta temperatura" },
    { img: img10, desc: "Sostanze velenose" },
    { img: img11, desc: "Sostanze corrosive" },
    { img: img12, desc: "Carichi sospesi" },
    { img: img13, desc: "Pericolo generico" },
    { img: img14, desc: "Caduta con dislivello" },
    { img: img15, desc: "Materiale comburente" },
    { img: img16, desc: "Sostanze nocive o irritanti" },
    { img: img17, desc: "Pericolo di inciampo" },
    {
      isHeader: true,
      title:
        "Segnali di Obbligo: Obbligano ad indossare un DPI e a tenere un comportamento di sicurezza.",
    },
    { img: img18, desc: "Protezione obbligatoria per gli occhi" },
    { img: img19, desc: "Casco di protezione obbligatorio" },
    { img: img20, desc: "Protezione obbligatoria dell'udito" },
    { img: img21, desc: "Protezione obbligatoria delle vie respiratorie" },
    { img: img22, desc: "Calzature di sicurezza obbligatorie" },
    { img: img23, desc: "Guanti di protezione obbligatori" },
    { img: img24, desc: "Obbligo generico" },
    {
      img: img25,
      desc: "Protezione individuale contro le cadute obbligatoria",
    },
    { img: img26, desc: "Protezione obbligatoria del corpo" },
    { img: img27, desc: "Protezione obbligatoria del viso" },
    { img: img28, desc: "Passaggio obbligatorio per i pedoni" },
    {
      isHeader: true,
      title:
        "Segnali di Indicazione: Danno indicazioni per l'operazione di salvataggio.",
    },
    { img: img29, desc: "Percorso/Uscita emergenza" },
    { img: img30, desc: "Kit Pronto soccorso" },
    { img: img31, desc: "Estintore" },
    { isHeader: true, title: "Comunicazioni Verbali e segnali gestuali." },
    {
      img: img32,
      desc: "Comando: Attenzione inizio operazioni\nVerbale: VIA\nGestuale: Le due braccia sono aperte in senso orizzontale, le palme delle mani rivolte in avanti.",
    },
    {
      img: img33,
      desc: "Comando: Alt interruzione fine del movimento\nVerbale: ALT\nGestuale: Il braccio destro è teso verso l'alto, con la palma della mano destra rivolta in avanti.",
    },
    {
      img: img34,
      desc: "Comando: Fine delle operazioni\nVerbale: FERMA\nGestuale: Le due mani sono giunte all'altezza del petto.",
    },
    {
      img: img35,
      desc: "Comando: Sollevare\nVerbale: SOLLEVA\nGestuale: Il braccio destro, teso verso l'alto... descrive lentamente un cerchio.",
    },
    {
      img: img36,
      desc: "Comando: Abbassare\nVerbale: ABBASSA\nGestuale: Il braccio destro teso verso il basso... descrive lentamente un cerchio.",
    },
    {
      img: img37,
      desc: "Comando: Distanza verticale\nVerbale: MISURA DELLA DISTANZA\nGestuale: Le mani indicano la distanza.",
    },
    {
      img: img39,
      desc: "Comando: Avanzare\nVerbale: AVANTI\nGestuale: Entrambe le braccia sono ripiegate... gli avanbracci compiono movimenti lenti in direzione del corpo.",
    },
    {
      img: img40,
      desc: "Comando: Retrocedere\nVerbale: INDIETRO\nGestuale: Entrambe le braccia piegate... gli avambracci compiono movimenti lenti che si allontanano dal corpo.",
    },
    {
      img: img41,
      desc: "Comando: A destra\nVerbale: A DESTRA\nGestuale: Il braccio destro... compie piccoli movimenti lenti nella direzione.",
    },
    {
      img: img42,
      desc: "Comando: A sinistra\nVerbale: A SINISTRA\nGestuale: Il braccio sinistro... compie piccoli movimenti lenti nella direzione.",
    },
    {
      img: img43,
      desc: "Comando: Pericolo alt o arresto di emergenza\nVerbale: ATTENZIONE\nGestuale: Entrambe le braccia tese verso l'alto; le palme delle mani rivolte in avanti.",
    },
    {
      img: img38,
      desc: "Comando: Distanza orizzontale\nVerbale: MISURA DELLA DISTANZA\nGestuale: Le mani indicano la distanza.",
    },
  ];

  // Preload images
  const loadedSigns = await Promise.all(
    safetySigns.map(async (s) => {
      if (s.isHeader) return s;
      const dataUrl = await loadImageAsDataUrl(s.img);
      return { ...s, dataUrl };
    }),
  );

  autoTable(doc, {
    startY: y,
    head: [["Segnale", "Descrizione"]],
    body: loadedSigns.map((s) => {
      if (s.isHeader)
        return [
          {
            content: s.title,
            colSpan: 2,
            styles: {
              fillColor: [240, 240, 240],
              fontStyle: "bold",
              halign: "center",
            },
          },
        ];
      return [
        { content: "", styles: { minCellHeight: 25 } },
        { content: s.desc, styles: { minCellHeight: 25 } },
      ];
    }),
    theme: "grid",
    headStyles: {
      fillColor: borderColor,
      textColor: 255,
      fontStyle: "bold",
    },
    styles: {
      fontSize: 11,
      valign: "middle",
      cellPadding: 3,
    },
    columnStyles: {
      0: { width: 30 },
      1: { width: "auto" },
    },
    rowPageBreak: "avoid",
    margin: { bottom: 25 },
    didDrawCell: (data) => {
      if (
        data.section === "body" &&
        data.column.index === 0 &&
        loadedSigns[data.row.index] &&
        !loadedSigns[data.row.index].isHeader
      ) {
        const sign = loadedSigns[data.row.index];
        if (sign.dataUrl) {
          doc.addImage(
            sign.dataUrl,
            "PNG",
            data.cell.x + 2.5,
            data.cell.y + 2.5,
            20,
            20,
          );
        }
      }
    },
  });

  y = doc.lastAutoTable.finalY + 10;

  // Testo aggiuntivo da testo.md
  const testoSicurezzaAggiuntivo = [
    {
      type: "p",
      text: "Nel caso di scavi realizzati in prossimità di zone di passaggio di pedoni e/o automezzi sarà posizionata una segnaletica di sicurezza idonea quale transenne o nastro a strisce bianche e rosse.",
    },
    { type: "h", text: "SEGNALETICA STRADALE TEMPORANEA" },
    {
      type: "p",
      text: "I lavori ed i depositi su strada e i relativi cantieri stradali sono dotati di sistemi di segnalazione temporanea; i segnali di pericolo o di indicazione hanno colore di fondo giallo.",
    },
    {
      type: "p",
      text: "Per gli eventuali zavorramenti dei sostegni è vietato l’uso di materiali rigidi che possono costituire pericolo o intralcio per la circolazione.",
    },
    {
      type: "p",
      text: "I segnali sono scelti ed installati in maniera appropriata; si presta particolare attenzione a non porre in opera segnali temporanei e segnali permanenti in contrasto tra di loro. A tal fine i segnali permanenti vanno rimossi se in contrasto con quelli temporanei.",
    },
    {
      type: "p",
      text: "L’adozione delle misure per i lavori che si protraggono oltre le quarantotto ore, sara’ ratificata alle autorità competente.",
    },
    {
      type: "p",
      text: "Gli accorgimenti necessari alla sicurezza e alla fluidità della circolazione nel tratto di strada che precede un cantiere o una zona di lavoro o di deposito di materiali, consistono in un segnalamento adeguato alle velocità consentite ai veicoli, alle dimensioni della deviazione ed alle manovre da eseguire all’altezza del cantiere, al tipo di strada e alle situazioni di traffico e locali.",
    },
    { type: "h", text: "DELIMITATORI" },
    {
      type: "p",
      text: "Barriere: segnalano i limiti dei cantieri stradali. Sono disposte parallelamente al piano stradale e sostenute da cavalletti o altri sostegni idonei. Sono obbligatorie sui lati frontali di delimitazione del cantiere o sulle testate di approccio. Lungo i lati longitudinali possono essere sostituite da recinzioni colorate.",
    },
    {
      type: "p",
      text: "Cono: usato per delimitare ed evidenziare zone di lavoro o operazioni di manutenzione di breve durata. È di colore rosso con anelli di colore bianco retroriflettenti.",
    },
    {
      type: "p",
      text: "Delineatore flessibile: deve essere usato per delimitare i sensi di marcia contigui, opposti o paralleli, e per circondare zone di lavoro ed operazioni di manutenzione di lunga durata.",
    },
    { type: "h", text: "SEGNALATORI LUMINOSI" },
    {
      type: "p",
      text: "Segnalatori luminosi a luce fissa e/o lampeggiante: ad integrazione della visibilità dei mezzi segnaletici rifrangenti, durante le ore notturne ed in tutti i casi di scarsa visibilità, le barriere delle zone di lavoro devono essere munite di idonei apparati luminosi di colore rosso a luce fissa e a luce gialla lampeggiante. Sono vietate le lanterne, od altre sorgenti",
    },
    {
      type: "p",
      text: "Si riportano alcune misure di sicurezza supplementari, che possono essere adottate nel caso si evidenzi la necessità di risultare visibili e di richiamare l’attenzione:",
    },
    {
      type: "p",
      text: "- obbligo di operare con i sistemi di illuminazione installati sui veicoli (girofari o luci di profondità) sempre attivi al fine di rendere più visibili i mezzi operativi del cantiere",
    },
    {
      type: "p",
      text: "- obbligo di installare un segnalatore acustico di retromarcia sui veicoli operanti in cantiere (autocarri, furgoni, mezzi operativi...)",
    },
    { type: "h", text: "GESTIONE DELL’EMERGENZA E DEL PRONTO SOCCORSO" },
    {
      type: "p",
      text: "In relazione alle particolari condizioni di lavoro (isolamento ambientale, situazione climatica, ecc.) è presente la necessaria dotazione di presidi sanitari, ad uso degli addetti sanitari per prestare le prime immediate cure a lavoratori feriti o colpiti da malore improvviso.",
    },
    { type: "h", text: "Gestione emergenze e pronto soccorso" },
    {
      type: "p",
      text: "La gestione delle emergenze, della lotta antincendio e la predisposizione di un servizio o di presidi per il pronto soccorso è richiesta dal D.lgs. 81/08, dal DM 10/3/98 e dal DM 388/2003.",
    },
    {
      type: "p",
      text: "Sono state valutate le specifiche situazioni degli ambienti di lavoro (attività svolte, personale presente, personale soggetto a visite periodiche) al fine di stabilire l’estensione dell’organizzazione per la lotta contro le emergenze e, sentito il Medico Competente, le esigenze per il pronto soccorso.",
    },
    {
      type: "p",
      text: "Sono stati predisposti adeguati presidi per il pronto soccorso secondo il DM 388/2003 e le indicazioni del Medico Competente.",
    },
    {
      type: "p",
      text: "La sorveglianza sanitaria è prevista dall’art. 41 del D.lgs. 81/08 che richiede di individuare le attività per le quali la legge prescrive tale sorveglianza.",
    },
    {
      type: "p",
      text: "Sono state individuate attività lavorative per le quali è prescritta la sorveglianza sanitaria; si è pertanto provveduto alla nomina del Medico Competente.",
    },
    {
      type: "p",
      text: "Il personale è sottoposto a sorveglianza sanitaria secondo il programma ed i protocolli definiti dal Medico Competente.",
    },
  ];

  testoSicurezzaAggiuntivo.forEach((item) => {
    doc.setFont("helvetica", item.type === "h" ? "bold" : "normal");
    doc.setFontSize(item.type === "h" ? 12 : 11);
    doc.setTextColor(0);

    const prefix = item.type === "li" ? "▪ " : "";
    const textToPrint = prefix + item.text;

    // Check space
    const splitText = doc.splitTextToSize(textToPrint, contentWidth);
    const neededHeight = splitText.length * 5 + 2;
    const checkHeight = item.type === "h" ? neededHeight + 15 : neededHeight;

    if (y + checkHeight > pageHeight - 20) {
      doc.addPage();
      addHeader(doc);
      y = 45;
    }

    doc.text(splitText, marginLeft, y);
    y += neededHeight + (item.type === "h" ? 2 : 0); // Extra space after headers
  });

  // --- TABELLE PRONTO SOCCORSO ED EMERGENZE ---
  y += 5;

  // Tabella 1: Cassetta Pronto Soccorso
  const prontoSoccorsoData = [
    ["1", "Flacone disinfettante ml.250"],
    ["1", "Benda garza idrofila da cm.7x5m"],
    ["2", "Bende garza idrofila da cm.5x5m"],
    ["1", "rocchetto cerotto mt.1x2cm"],
    ["50", "compresse garza sterile cm.10x10"],
    ["1", "confezione da 10 cerotti medicati"],
    ["1", "telo sterile TNT cm.60x40"],
    ["1", "flacone ammoniaca"],
    ["1", "paio di forbici"],
    ["3", "spille sicurezza"],
    ["3", "bustine sapone liquido"],
    ["2", "rotoli di benda orlata alta cm.10"],
    ["1", "pacchetto cotone idrofilo"],
    ["1", "foglio decreto ministeriale"],
  ];

  if (y + 15 > pageHeight - 20) {
    doc.addPage();
    addHeader(doc);
    y = 45;
  }

  doc.setFont("helvetica", "bold");
  doc.setFontSize(11);
  doc.text(
    "Contenuto previsto nella cassetta di pronto soccorso:",
    marginLeft,
    y,
  );
  y += 5;

  autoTable(doc, {
    startY: y,
    head: [["Q.tà", "Descrizione"]],
    body: prontoSoccorsoData,
    theme: "grid",
    headStyles: { fillColor: borderColor, textColor: 255, fontStyle: "bold" },
    styles: { fontSize: 10, cellPadding: 3 },
    columnStyles: {
      0: { width: 15, halign: "center" },
      1: { width: "auto" },
    },
    margin: { bottom: 25 },
  });

  y = doc.lastAutoTable.finalY + 10;

  // Tabella 2: Numeri Emergenza
  const emergenzaData = [
    ["Vigili del fuoco", "115"],
    ["Guardia di finanza", "117"],
    ["Polizia di Stato", "113"],
    ["Numero unico emergenze", "112"],
    ["Emergenza sanitaria", "118"],
  ];

  if (y + 15 > pageHeight - 20) {
    doc.addPage();
    addHeader(doc);
    y = 45;
  }

  doc.setFont("helvetica", "bold");
  doc.setFontSize(11);
  doc.text(
    "ELENCO DEI NUMERI TELEFONICI UTILI IN CASO DI EMERGENZA SANITARIA",
    marginLeft,
    y,
  );
  y += 5;

  autoTable(doc, {
    startY: y,
    head: [["Ente", "Numero Telefonico"]],
    body: emergenzaData,
    theme: "grid",
    headStyles: { fillColor: borderColor, textColor: 255, fontStyle: "bold" },
    styles: { fontSize: 10, cellPadding: 3 },
    columnStyles: {
      0: { width: "auto" },
      1: { width: 40, halign: "center" },
    },
    margin: { bottom: 25 },
  });

  y = doc.lastAutoTable.finalY + 10;

  // --- Procedure di Chiamata Emergenza ---
  const emergencyProcedures = [
    { type: "h", text: "MODALITÀ DI CHIAMATA DEL VIGILI DEL FUOCO 115" },
    { type: "p", text: "Comunicare i seguenti dati:" },
    { type: "li", text: "Indirizzo preciso del cantiere;" },
    {
      type: "li",
      text: "Indicazioni del percorso e punti di riferimento per una rapida localizzazione del sito;",
    },
    { type: "li", text: "Tipo d'incendio (piccolo, medio , grande);" },
    { type: "li", text: "Nominativo di chi sta chiamando." },
    { type: "h", text: "MODALITÀ DI CHIAMATA DELL'EMERGENZA SANITARIA 118" },
    { type: "p", text: "Comunicare i seguenti dati:" },
    { type: "li", text: "Indirizzo preciso del cantiere;" },
    {
      type: "li",
      text: "Indicazioni del percorso e punti di riferimento per una rapida localizzazione del sito;",
    },
    { type: "li", text: "Patologia presentata dalla persona colpita;" },
    {
      type: "li",
      text: "(ustione, emorragia, frattura, arresto respiratorio, arresto cardiaco, shock, ecc.);",
    },
    {
      type: "li",
      text: "Stato della persona colpita (cosciente, incosciente);",
    },
    { type: "li", text: "Nominativo di chi sta chiamando." },
    { type: "p", text: "" }, // Spacer
    {
      type: "h",
      text: "IN ENTRAMBI I CASI SUCCESSIVAMENTE POSIZIONARSI IN POSIZIONE VISIBILE PER ACCOGLIERE I SOCCORRITORI",
    },
  ];

  emergencyProcedures.forEach((item) => {
    doc.setFont("helvetica", item.type === "h" ? "bold" : "normal");
    doc.setFontSize(item.type === "h" ? 11 : 11);
    doc.setTextColor(0);

    const prefix = item.type === "li" ? "- " : "";
    const textToPrint = prefix + item.text;

    // Check space
    const splitText = doc.splitTextToSize(textToPrint, contentWidth);
    const neededHeight = splitText.length * 5 + 2;
    const checkHeight = item.type === "h" ? neededHeight + 15 : neededHeight;

    if (y + checkHeight > pageHeight - 20) {
      doc.addPage();
      addHeader(doc);
      y = 45;
    }

    doc.text(splitText, marginLeft, y);
    y += neededHeight + (item.type === "h" ? 2 : 0);
  });

  // --- Gestione Emergenza Antincendio ---
  y += 15;

  const fireEmergencyData = [
    { type: "h", text: "GESTIONE EMERGENZA ANTINCENDIO" },
    {
      type: "p",
      text: "Per quanto riguarda la presenza di idonei mezzi di estinzione nel cantiere e la gestione dell’emergenza antincendio si elenca la dotazione disponibile:",
    },
    {
      type: "p",
      text: "Tenuto conto che in presenza del Piano di Sicurezza e Coordinamento gli apprestamenti e le procedure ai fini dell’antincendio sono previsti all’interno del documento, si elencano unicamente i mezzi a disposizione della Ditta appaltatrice.",
    },
    {
      type: "p",
      text: "Tutti i lavoratori dovranno attenersi alle norme generali di comportamento e in particolare dovranno:",
    },
    {
      type: "li",
      text: "evitare gli accatastamenti, anche temporanei, di materiali facilmente infiammabili (carta, cartoni, materie plastiche, ecc.) provvedendo prontamente a posizionarli nelle aree allo scopo predisposte;",
    },
    { type: "li", text: "mantenere sempre libere le vie di fuga;" },
    {
      type: "li",
      text: "evitare di rimuovere gli estintori dai luoghi previsti, provvedendo a segnalare al diretto superiore la loro eventuale assenza;",
    },
    {
      type: "li",
      text: "segnalare eventuali anomalie (ad es. guasti all'impianto elettrico, presenza di ingombri lungo le vie di fuga o le uscite di sicurezza, perdite di liquidi come acqua, prodotti utilizzati sul cantiere, gas, ecc., principi d'incendio) al diretto superiore.",
    },
    { type: "p", text: "Ciascun lavoratore dovrà:" },
    {
      type: "li",
      text: "informare il suo diretto superiore ogni qual volta riscontri il verificarsi di una situazione pericolosa, indicando con chiarezza la natura dell'emergenza e la zona del cantiere interessata;",
    },
    {
      type: "li",
      text: "intervenire, se in presenza di un principio d'incendio e dopo l'immediata comunicazione da effettuarsi con le modalità precedentemente illustrate, utilizzando esclusivamente gli estintori a disposizione;",
    },
    {
      type: "li",
      text: "allontanarsi senza indugio, qualora venga dato l'ordine di evacuazione mediante l'attivazione dell'allarme, lungo i percorsi di emergenza, per raggiungere il punto di riunione prestabilito, dove un addetto provvederà a verificare eventuali assenze. Se ne ha la possibilità, inoltre, prima di abbandonare il posto di lavoro dovrà mettere in sicurezza le attrezzature e le macchine utilizzate, con priorità per quelle maggiormente in grado di generare a loro volta situazioni di pericolo;",
    },
    {
      type: "li",
      text: "al termine dell'evacuazione quando si è giunti in luogo sicuro, allontanarsi dai percorsi di esodo, per non ostacolare il deflusso degli altri lavoratori e/o dei soccorritori.",
    },
  ];

  fireEmergencyData.forEach((item) => {
    doc.setFont("helvetica", item.type === "h" ? "bold" : "normal");
    doc.setFontSize(item.type === "h" ? 12 : 11);
    doc.setTextColor(0);

    const prefix = item.type === "li" ? "- " : "";
    const textToPrint = prefix + item.text;

    // Check space
    const splitText = doc.splitTextToSize(textToPrint, contentWidth);
    const neededHeight = splitText.length * 5 + 2;
    const checkHeight = item.type === "h" ? neededHeight + 15 : neededHeight;

    if (y + checkHeight > pageHeight - 20) {
      doc.addPage();
      addHeader(doc);
      y = 45;
    }

    doc.text(splitText, marginLeft, y);
    y += neededHeight + (item.type === "h" ? 2 : 0);
  });

  // --- Pagina 10: Gestione Contratti e Documentazione ---
  doc.addPage();
  addHeader(doc);
  y = 45;
  doc.setFontSize(16);
  doc.setTextColor(borderColor[0], borderColor[1], borderColor[2]);
  doc.text("Gestione Contratti e Documentazione", marginLeft, y);
  y += 10;

  const contratti = posData.GestioneContratti || "";
  doc.setFontSize(11);
  doc.setTextColor(0);
  if (Array.isArray(contratti)) {
    contratti.forEach((c) => {
      doc.text(`• ${c}`, marginLeft + 5, y);
      y += 6;
    });
  } else {
    doc.text(
      doc.splitTextToSize(String(contratti), contentWidth),
      marginLeft,
      y,
    );
  }

  // --- Pagina 11: Macchine ed Attrezzature ---
  doc.addPage();
  addHeader(doc);
  y = 45;
  doc.setFontSize(16);
  doc.setTextColor(borderColor[0], borderColor[1], borderColor[2]);
  doc.text("Elenco delle Macchine ed Attrezzature", marginLeft, y);
  y += 10;

  doc.setFontSize(11);
  doc.setTextColor(0);
  doc.text(
    doc.splitTextToSize(
      "Per la realizzazione delle attività lavorative dell’impresa sono utilizzate macchine ed attrezzature di lavoro, in corrispondenza a relativamente alle quali si riportano le procedure per l’utilizzo in sicurezza:",
      contentWidth,
    ),
    marginLeft,
    y,
  );
  y += 15;

  // List of machines
  let macchineData = [];
  // Prioritize posData if available (AI integration)
  const sourceMacchine =
    posData.Macchine || posData.Attrezzature || posData.ElencoMacchine;

  if (Array.isArray(sourceMacchine) && sourceMacchine.length > 0) {
    macchineData = sourceMacchine.map((m, i) => {
      const name =
        typeof m === "object"
          ? m.nome || m.descrizione || m.text || JSON.stringify(m)
          : m;
      return [String(i + 1), name];
    });
  } else {
    // Default/Standard list from testo.md
    const standardMachines = [
      "Autocarro",
      "Autocarro",
      "Autocarro",
      "Autocarro",
      "Autovettura",
      "Autocarro",
      "Scale",
      "Trapani",
      "Avvitatori",
      "Ponteggio",
      "Misuratore di terra",
      "Multimetro digitale da laboratorio",
      "Oscilloscopio",
    ];
    macchineData = standardMachines.map((m, i) => [String(i + 1), m]);
  }

  autoTable(doc, {
    startY: y,
    head: [["N°", "DESCRIZIONE UNITA"]],
    body: macchineData,
    theme: "grid",
    headStyles: { fillColor: borderColor, textColor: 255, fontStyle: "bold" },
    styles: { fontSize: 10, cellPadding: 3 },
    columnStyles: {
      0: { width: 15, halign: "center" },
      1: { width: "auto" },
    },
    margin: { bottom: 25 },
  });

  y = doc.lastAutoTable.finalY + 10;

  // Text from testo.md
  const maintenanceText = [
    {
      type: "h",
      text: "RIFERIMENTI ALLE NORME COGENTI E/O ALLE REGOLE DI BUONA TECNICA",
    },
    {
      type: "p",
      text: "Esistono una serie di disposizioni legislative e regolamentari che riguardano i requisiti di sicurezza per le macchine. I principali provvedimenti sono il D.lgs. 81/08 – Titolo III e il DPR 459/96 che recepisce la direttiva comunitaria 89/37/CE (“direttiva macchine”).",
    },
    {
      type: "p",
      text: "Secondo quanto stabilito dall’art. 70 del D.lgs. 81/08, le attrezzature di lavoro messe a disposizione dei lavoratori sono conformi alle specifiche disposizioni legislative di recepimento delle direttive comunitarie di prodotto (direttiva macchine e altre direttive specifiche di prodotto), ad esclusione delle attrezzature costruite in assenza di tali disposizioni o messe a disposizione prima del recepimento di specifiche direttive comunitarie (In questo caso le attrezzature sono conformi ai requisiti generali di sicurezza previsti all’allegato V del D.lgs. 81/08).",
    },
    { type: "h", text: "MISURE DI PREVENZIONE E PROTEZIONE GENERALI PREVISTE" },
    {
      type: "p",
      text: "Le principali misure organizzative e tecniche affinché le macchine, in base alla loro tipologia tecnologica, si mantengano in adeguate condizioni relativamente alla prevenzione degli infortuni sono di seguito indicate.",
    },
    {
      type: "p",
      text: "Le macchine di nuova introduzione devono essere dotate di marcatura CE e di manuale di istruzioni o, se usate, deve essere dichiarata dal venditore la conformità alla legislazione previgente, cui deve seguire comunque una verifica di conformità interna.",
    },
    {
      type: "p",
      text: "Tutte le macchine e gli impianti non rispondenti alle leggi attualmente in vigore, quando possibile sono immediatamente messe fuori servizio, fino ad loro completo adeguamento; quando non sarà possibile metterli fuori servizio, in attesa di adeguamento, si adotteranno particolari e specifici accorgimenti per ridurre i livelli di rischio dei dipendenti (es. misure organizzative, limitazioni di utilizzo, ecc.).",
    },
    {
      type: "p",
      text: "• Tutti gli organi in movimento devono essere protetti contro i contatti accidentali.",
    },
    {
      type: "p",
      text: "• Devono esistere schermi per prevenire il rischio di proiezione di oggetti e frammenti.",
    },
    {
      type: "p",
      text: "• Devono essere installati e funzionanti sistemi di captazione ed aspirazione di vapori, polveri e liquidi.",
    },
    {
      type: "p",
      text: "• I dispositivi di protezione meccanici ed elettrici devono essere presenti, idonei ed attivati.",
    },
    {
      type: "p",
      text: "• Dopo manutenzione, i dispositivi eventualmente rimossi devono essere immediatamente ripristinati.",
    },
    {
      type: "p",
      text: "• Gli organi di azionamento devono essere manovrabili solo in modo intenzionale.",
    },
    {
      type: "p",
      text: "• Le macchine devono essere dotate di pulsante di arresto in emergenza in posizione facilmente accessibile.",
    },
    {
      type: "p",
      text: "• In caso di interruzione di EE la macchina devono essere riavviata dall’operatore.",
    },
    {
      type: "p",
      text: "• Le macchine devono essere illuminate in modo idoneo alla lavorazione.",
    },
    {
      type: "p",
      text: "• Non devono esistere parti a spigolo sporgenti in modo pericoloso.",
    },
    {
      type: "p",
      text: "• Le macchine devono essere posizionate in modo stabile.",
    },
    {
      type: "p",
      text: "• Devono esistere espliciti divieti di operazioni di pulizia o manutenzione delle macchine in moto.",
    },
    {
      type: "p",
      text: "• Cinghie, funi, nastri ed organi di trasmissione devono essere protetti.",
    },
    {
      type: "p",
      text: "• Tra le macchine e tra queste e le pareti deve esistere uno spazio libero di almeno 0.5 m nel caso di movimenti alternativi degli organi.",
    },
    {
      type: "p",
      text: "• Deve esistere idonea cartellonistica per ciascuna macchina con l’indicazione dei pericoli e dei mezzi di protezione personale da utilizzare.",
    },
    {
      type: "p",
      text: "• Devono essere fornite adeguate informazioni ed emesse apposite procedure di sicurezza.",
    },
    {
      type: "p",
      text: "Relativamente alle attrezzature principali utilizzate in cantiere si riportano in Allegati 01 le procedure per il loro utilizzo in sicurezza: le prescrizioni riportate devono essere osservate dagli addetti dell’impresa.",
    },
    {
      type: "p",
      text: "Si precisa che nei casi in cui non sono specificate precise procedure di lavoro, ed in particolare per la strumentazione elettrica utilizzata in attività di verifica e diagnosi delle reti, trattandosi di attrezzature con scarso rischio prevalentemente elettrico, occorre riferirsi alle schede degli elettrici e manuali.",
    },
    { type: "h", text: "CONTROLLI, MANUTENZIONE, VERIFICHE E COLLAUDI" },
    {
      type: "p",
      text: "La regolare manutenzione di ambienti, attrezzature, macchine e impianti, con particolare riferimento ai dispositivi di sicurezza è una delle misure generali di tutela previste dall’art. 15 del D.lgs. 81/08.",
    },
    {
      type: "p",
      text: "L’organizzazione prevede quindi l’effettuazione di manutenzione periodica e di collaudo di ambienti, attrezzature, impianti, macchinari e loro parti che presentino rischi per i lavoratori. Le attività di manutenzione sono programmate in modo da non interferire negativamente con l’attività degli altri lavoratori.",
    },
    {
      type: "p",
      text: "Sulle attrezzature di lavoro vengono inoltre eseguite le verifiche periodiche previste dall’allegato VII del D.lgs. 81/08, secondo le periodicità previste dall’allegato stesso",
    },
  ];

  maintenanceText.forEach((item) => {
    doc.setFont("helvetica", item.type === "h" ? "bold" : "normal");
    doc.setFontSize(item.type === "h" ? 12 : 11);
    doc.setTextColor(0);

    // Check space
    const splitText = doc.splitTextToSize(item.text, contentWidth);
    const neededHeight = splitText.length * 5 + 2;
    const checkHeight = item.type === "h" ? neededHeight + 15 : neededHeight;

    if (y + checkHeight > pageHeight - 20) {
      doc.addPage();
      addHeader(doc);
      y = 45;
    }

    doc.text(splitText, marginLeft, y);
    y += neededHeight + (item.type === "h" ? 2 : 0);
  });

  // --- Pagina 16: Elenco dei DPI ---
  doc.addPage();
  addHeader(doc);
  y = 45;
  doc.setFontSize(16);
  doc.setTextColor(borderColor[0], borderColor[1], borderColor[2]);
  doc.text("Elenco dei DPI", marginLeft, y);
  y += 10;

  // Load DPI image
  const dpiDataUrl = await loadImageAsDataUrl(DpiImg);

  const dpiTextPart1 = [
    { type: "p", text: "(Dispositivi di protezione individuale)" },
    {
      type: "p",
      text: "L’uso dei dispositivi di protezione individuale è disciplinato dal D. Lgs. 81/08 (Titolo III – Capo II). La commercializzazione e la marcatura CE dei DPI sono regolamentati dal D. Lgs. 475/1992, così come modificato dal D. Lgs. 10/1997.",
    },
    {
      type: "p",
      text: "Per quanto riguarda i criteri per l'individuazione e l'uso dei dispositivi di protezione individuale (DPI) si richiamano inoltre le seguenti norme tecniche:",
    },
    {
      type: "p",
      text: "a) UNI EN 458: 1995 relativa alla protezione dell'udito,",
    },
    {
      type: "p",
      text: "b) UNI 10720: 1998 relativa alla protezione delle vie respiratorie,",
    },
    {
      type: "p",
      text: "c) UNI EN 169: 1993, UNI EN 170: 1993, UNI EN 171: 1993 relative alla protezione degli occhi (filtri per saldatura e tecniche connesse, filtri per radiazioni ultraviolette, filtri per radiazioni infrarosse),",
    },
    {
      type: "p",
      text: "d) UNI 9609: 1990 relativa a indumenti protettivi da agenti chimici.",
    },
    {
      type: "p",
      text: "La valutazione sulle esigenze dei DPI è costantemente aggiornata. I lavoratori sono consultati nella scelta dei DPI più idonei, informati e formati circa la necessità e il corretto uso degli stessi.",
    },
    {
      type: "p",
      text: "Nella scelta dei DPI sono tenuti in considerazione i fattori ergonomici e, per quanto possibile, l’eventuale disagio manifestato dal lavoratore.",
    },
    {
      type: "p",
      text: "La direzione richiede l’uso dei DPI e sanziona i lavoratori inadempienti.",
    },
    {
      type: "p",
      text: "Ai lavoratori sono stati assegnati tutti i dispositivi di protezione, informazioni per la manutenzione e/o sostituzione degli stessi in caso di usura, e le istruzioni per l’uso.",
    },
    {
      type: "p",
      text: "Sono successivamente riportati, in relazione alle mansioni svolte, i DPI messi a disposizione dei lavoratori e le modalità per il loro utilizzo.",
    },
    {
      type: "p",
      text: "I lavoratori sono dotati di regolari DPI con marcatura “CE”, in particolare:",
    },
    {
      type: "p",
      text: "guanti - calzature di sicurezza - elmetto - cuffie o tappi - occhiali",
    },
  ];

  dpiTextPart1.forEach((item) => {
    doc.setFont("helvetica", "normal");
    doc.setFontSize(11);
    doc.setTextColor(0);

    const splitText = doc.splitTextToSize(item.text, contentWidth);
    const neededHeight = splitText.length * 5 + 2;

    y = checkPageBreak(y, neededHeight);
    doc.text(splitText, marginLeft, y);
    y += neededHeight;
  });

  // Image insertion
  if (dpiDataUrl) {
    const imgHeight = 25; // Adjusted height for DPI image
    y = checkPageBreak(y, imgHeight + 10);
    // Centered image
    doc.addImage(dpiDataUrl, "PNG", marginLeft, y, 170, imgHeight);
    y += imgHeight + 5;
  }

  const dpiTextPart2 = [
    {
      type: "p",
      text: "Il datore di lavoro, ha messo a disposizione dei lavoratori mezzi personali di protezione appropriati ai rischi inerenti alle lavorazioni ed operazioni effettuate, qualora manchino o siano insufficienti i mezzi tecnici di protezione.",
    },
    {
      type: "p",
      text: "I detti mezzi personali di protezione possiedono i necessari requisiti di resistenza e di idoneità nonché essere mantenuti in buono stato di conservazione.",
    },
    {
      type: "p",
      text: "A partire dal 21 settembre 1996 tutti i dispositivi di protezione individuali sono provvisti di marcatura CE da parte del costruttore, che prevede tra l’altro la fornitura di adeguate istruzioni per l’uso con il prodotto.",
    },

    { type: "h", text: "PROTEZIONE DEI PIEDI" },
    { type: "h2", text: "Scarpe antinfortunistiche" },
    {
      type: "p",
      text: "Per la protezione dei piedi nelle lavorazioni in cui esistono specifici pericoli di punture o schiacciamento, i lavoratori sono provvisti di calzature resistenti ed adatte alla particolare natura del rischio (art. 384 DPR 547/55)",
    },
    {
      type: "p",
      text: "Per gli addetti a lavori che prevedono movimentazioni di carichi pesanti ed in tutti i casi in cui sussista il pericolo di caduta di oggetti sono previste calzature con puntale in acciaio.",
    },
    {
      type: "p",
      text: "Quando vi è pericolo di punture ai piedi (chiodi, vetri, ecc.) sono previste scarpe con suole rinforzate per mezzo di lamine di acciaio. Ai fini antinfortunistici la suola è antisdrucciolo.",
    },

    { type: "h", text: "PROTEZIONI ALLE MANI" },
    {
      type: "p",
      text: "Nelle lavorazioni che presentano specifici pericoli di punture, tagli, abrasioni, ustioni alle mani, i lavoratori sono stati forniti di manopole, guanti e altri appropriati mezzi di protezione (art.383 DPR 164/56)",
    },
    {
      type: "p",
      text: "Il guanto deve avere caratteristiche specifiche in relazione al tipo di agente nocivo da cui deve proteggere:",
    },
    {
      type: "l",
      text: "• guanti di cotone, per protezione da imbrattamenti o da limitata azione abrasiva",
    },
    {
      type: "l",
      text: "• guanti di cuoio crosta di tipo normale o rinforzato, per protezione da tagli, punture, abrasioni",
    },
    {
      type: "l",
      text: "• guanti dielettrici, per lavori su impianti elettrici",
    },
    {
      type: "l",
      text: "• guanti di gomma, neoprene, PVC. per la protezione da acidi, solventi, refrigeranti, tossici;",
    },
    {
      type: "l",
      text: "• guanti in tessuto isolante per maneggio di particolari ad alta temperatura.",
    },

    { type: "h", text: "PROTEZIONE DEL CAPO" },
    {
      type: "p",
      text: "I lavoratori esposti a specifici pericoli di lesioni al capo per caduta di materiali dall’alto o per contatti con elementi comunque pericolosi sono stati provvisti di copricapo appropriato. (art.381 DPR 164/56).",
    },
    {
      type: "p",
      text: "L’elmetto dovrà soddisfare a specifiche condizioni in relazione alla natura del rischio esistente (antiurto, anticaduta, dielettrico ecc.)",
    },

    { type: "h", text: "PROTEZIONE DEGLI OCCHI" },
    {
      type: "p",
      text: "I lavoratori esposti al pericolo di offesa agli occhi per proiezioni di schegge o di materiali roventi, caustici, corrosivi o comunque dannosi, sono stati muniti di occhiali, visiere o schermi appropriati (art. 382 DPR 164/56).",
    },

    { type: "h", text: "PROTEZIONE DELL’UDITO" },
    {
      type: "p",
      text: "La protezione dell’apparato uditivo è basata soprattutto sull’impiego di mezzi finalizzati a ridurre l’intensità dell’onda sonora che raggiunge l’orecchio interno.",
    },
    {
      type: "p",
      text: "I dispositivi di protezione individuali sono rappresentati, sostanzialmente, da:",
    },
    {
      type: "l",
      text: "• tappi di lana-piuma che se inseriti correttamente nel canale auricolare consentono attenuazioni dai 15 ai 25 dB a seconda delle frequenze",
    },
    {
      type: "l",
      text: "• cuffie che presentano un potere di attenuazione maggiore in quanto trattengono anche le vibrazioni che verrebbero trasmesse per via ossea.",
    },

    { type: "h", text: "PROTEZIONE ALLE VIE RESPIRATORIE" },
    {
      type: "p",
      text: "I lavoratori esposti a specifici rischi di inalazioni pericolose di gas, polveri o fumi nocivi hanno a disposizione maschere respiratorie e altri dispositivi idonei, sono stati informati che sono da conservarsi in luogo adatto facilmente accessibile e noto al personale (art. 387 DPR 164/56).",
    },
    {
      type: "p",
      text: "Per le vie respiratorie vengono impiegati i seguenti mezzi protettivi:",
    },
    { type: "l", text: "• maschera a filtro (per polvere, nebbie, fumi, gas)" },
    {
      type: "l",
      text: "• maschera a presa d’aria dall’esterno o con alimentazione d’aria da compressori",
    },
    { type: "l", text: "• auto protettori o autorespiratori" },

    { type: "h", text: "DISPOSITIVI ANTICADUTA" },
    {
      type: "p",
      text: "I lavoratori che sono esposti a pericolo di caduta dall’alto, entro vani o entro pozzi, cisterne e simili in condizioni di pericolo, sono provvisti di adatta cintura di sicurezza (art.386 DPR 164/56).",
    },
    {
      type: "p",
      text: "Le cinture di posizionamento sul lavoro (dotate di due anelli laterali di presa) sono necessarie in particolare quando si lavora su una scala o su una piattaforma, limitando il rischio di caduta a non più di 50 cm mediante cordino di stazionamento sul lavoro opportunamente regolato.",
    },
    {
      type: "p",
      text: "Nelle situazioni di lavoro dove esiste un rischio di caduta dall’alto e con eventuale necessità di spostamenti in quota accorre una imbracatura anticaduta per l’operatore. Tale imbracatura deve essere utilizzata con l’attacco dorsale o ventrale connesso con idoneo sistema anticaduta dotato di assorbitore o dissipatore di energia, destinato a limitare le sollecitazioni della colonna vertebrale in caso di caduta.",
    },
    {
      type: "p",
      text: "Occorre infine dotarsi di un attacco sicuro, idoneo per esempio a reggere almeno 12KN (circa 1200kg) per collegamenti a fune e 15KN (1500kg) per agganci puntuali (UNI EN 795).",
    },

    { type: "h", text: "INDUMENTI AD ALTA VISIBILITÀ" },
    {
      type: "p",
      text: "Coloro che operano in prossimità della delimitazione di un cantiere o sono esposti al traffico dei veicoli nello svolgimento della loro attività lavorativa, devono essere visibili sia di giorno che di notte, e sono quindi dotati di indumenti di lavoro fluorescenti e rifrangenti. Tutti gli indumenti devono essere realizzati con tessuto di base fluorescente di colore arancio o giallo o rosso con applicazione di fasce rifrangenti di colore bianco argento (classe 2 e 3).",
    },
    {
      type: "p",
      text: "In caso di interventi di breve durata può essere utilizzata una bretella realizzata con materiale sia fluorescente che rifrangente di colore arancio.",
    },

    {
      type: "p",
      text: "I lavoratori della GIUVI sono dotati dei DPI previsti dal presente piano di sicurezza ed hanno ricevuto informazione e formazione adeguate al loro uso, secondo quanto previsto dal Titolo IV del D. Lgs. 626/94.",
    },
  ];

  dpiTextPart2.forEach((item) => {
    if (item.type === "h") {
      doc.setFont("helvetica", "bold");
      doc.setFontSize(12);
    } else if (item.type === "h2") {
      doc.setFont("helvetica", "bold");
      doc.setFontSize(11);
    } else {
      doc.setFont("helvetica", "normal");
      doc.setFontSize(11);
    }
    doc.setTextColor(0);

    const splitText = doc.splitTextToSize(item.text, contentWidth);
    const neededHeight = splitText.length * 5 + 3;
    const checkHeight =
      item.type === "h" || item.type === "h2"
        ? neededHeight + 15
        : neededHeight;

    y = checkPageBreak(y, checkHeight);
    doc.text(splitText, marginLeft, y);
    y += neededHeight;
  });

  // --- Pagina 17: Stoccaggio di Materiali e Rifiuti ---
  doc.addPage();
  addHeader(doc);
  y = 45;
  doc.setFontSize(16);
  doc.setTextColor(borderColor[0], borderColor[1], borderColor[2]);
  doc.text("Stoccaggio di Materiali e Rifiuti", marginLeft, y);
  y += 10;

  const stoccaggioText = [
    {
      type: "p",
      text: "Restano identificate le aree di cantiere individuate per lo stoccaggio di materiali, attrezzature e rifiuti",
    },
    {
      type: "p",
      text: "Materiali ed attrezzature vengono collocati in aree di facile accessibilità e adeguatamente delimitate e segnalate. Gli stoccaggi dei materiali sono realizzati in modo da non costituire intralcio o pericolo alla circolazione pedonale o di mezzi.",
    },
    {
      type: "p",
      text: "Le macchine vengono ricoverate al termine dei lavori in posizione stabile e con eventuali elementi operatori ed organi sporgenti adeguatamente protetti.",
    },
    {
      type: "p",
      text: "Al termine o durante i lavori è necessario garantire una regolare raccolta ed asporto di eventuali macerie e residui di lavorazione; lo stoccaggio provvisorio sarà realizzato in modo tale da evitare cadute di materiale accidentali. Per determinare i fattori di rischio o pericoli per la sicurezza e per la salute connessi con l’uso o la presenza delle sostanze utilizzate, sono state prese in considerazione le schede di sicurezza approntate dai fornitori dei prodotti. Le schede di sicurezza permettono inoltre di identificare le misure di prevenzione e protezione ed i dispositivi di protezione individuale da utilizzare.",
    },

    { type: "h", text: "DESCRIZIONE AREE DI STOCCAGGIO" },
    {
      type: "p",
      text: "MATERIALI: Per lo stoccaggio dei materiali gli operatori si attengono alle indicazioni del committente.",
    },
    {
      type: "p",
      text: "ATTREZZATURE: I componenti e le attrezzature necessari alle lavorazioni verranno posizionati nelle aree definite e delimitate dall’impresa appaltatrice.",
    },
    {
      type: "p",
      text: "RIFIUTI: I rifiuti derivanti dalle lavorazioni (soprattutto materiale metallico) verranno immagazzinati in zone di deposito temporaneo secondo le disposizioni vigenti all’interno del sito.",
    },
  ];

  stoccaggioText.forEach((item) => {
    if (item.type === "h") {
      doc.setFont("helvetica", "bold");
      doc.setFontSize(12);
    } else {
      doc.setFont("helvetica", "normal");
      doc.setFontSize(11);
    }
    doc.setTextColor(0);

    const splitText = doc.splitTextToSize(item.text, contentWidth);
    const neededHeight = splitText.length * 5 + 3;
    const checkHeight = item.type === "h" ? neededHeight + 15 : neededHeight;

    y = checkPageBreak(y, checkHeight);
    doc.text(splitText, marginLeft, y);
    y += neededHeight;
  });

  // --- Pagina 18: Valutazione Rischio Rumore e Tutela Minori ---
  doc.addPage();
  addHeader(doc);
  y = 45;
  doc.setFontSize(16);
  doc.setTextColor(borderColor[0], borderColor[1], borderColor[2]);
  doc.text("Valutazione Rischio Rumore", marginLeft, y);
  y += 10;

  const rumoreText = [
    {
      type: "p",
      text: "Si riporta un estratto dei valori (livello di esposizione medio) assegnati ai gruppi omogenei dei lavoratori, individuati nel documento di Valutazione del Rischio redatto ai sensi del Titolo VIII, Capo II, del D. Lgs. 81/08 e s.m.i.",
    },
    {
      type: "p",
      text: "Come previsto dall’art. 190, comma 5, del D. Lgs. 81/08, il datore di lavoro può non effettuare la misurazione quando ritenga fondatamente che il Livello di Esposizione Personale (LEX,8h) di tutti i suoi lavoratori non superi gli 80 dB(A) e la pressione acustica di picco (ppeak) non superi 112 Pa.",
    },
    {
      type: "p",
      text: "Per quanto riguarda le imprese del settore elettrico in base a numerose indagini fonometriche effettuate, si è evidenziato un valore di LEP compreso fra 80 e 85 dB(A), che posiziona i suddetti operatori nella fascia di rischio medio-bassa.",
    },
    {
      type: "p",
      text: "Nonostante il livello di esposizione mediato sulle 8 ore di lavoro sia accettabile, l’utilizzo di apparecchiature come trapani, flessibili e martelli demolitori, è in grado di causare seri danni anche su tempi di utilizzo bassi. Pertanto tutto il personale potenzialmente addetto all’utilizzo di suddette apparecchiature è stato dotato di adeguati dispositivi di protezione individuale (cuffie antirumore) e informato sulle modalità di utilizzo.",
    },

    {
      type: "h2",
      text: "RIFERIMENTI ALLE NORME COGENTI E/O ALLE REGOLE DI BUONA TECNICA",
    },
    { type: "p", text: "D. Lgs. 81/08 – Titolo VIII – Capo II" },

    { type: "h2", text: "CRITERI SPECIFICI DI VALUTAZIONE DEI RISCHI" },
    {
      type: "p",
      text: "Si utilizzeranno le metodologie di valutazione e i riferimenti previsti dal D. Lgs. 81/08 – Titolo VIII – Capo II, e in particolare:",
    },
    {
      type: "l",
      text: "• i lavoratori esposti a LEX,8h < 80 dB(A) e ppeak < 112 Pa saranno considerati a rischio trascurabile;",
    },
    {
      type: "l",
      text: "• i lavoratori esposti a 80 dB(A) < LEX,8h < 85 dB(A) e 112 Pa < ppeak < 140 Pa, saranno considerati a rischio basso;",
    },
    {
      type: "l",
      text: "• i lavoratori esposti a 85 dB(A) < LEX,8h < 87 dB(A) e 140 Pa < ppeak < 200 Pa saranno considerati a rischio medio;",
    },
    {
      type: "l",
      text: "• tutti i lavoratori esposti a LEX,8h => 87 dB(A) e ppeak => 200 Pa saranno considerati a rischio elevato.",
    },

    { type: "h2", text: "Valutazione del rischio" },
    {
      type: "p",
      text: "Viene di seguito riportato il risultato della valutazione dell’esposizione a rumore degli addetti:",
    },
  ];

  rumoreText.forEach((item) => {
    if (item.type === "h") {
      doc.setFont("helvetica", "bold");
      doc.setFontSize(12);
    } else if (item.type === "h2") {
      doc.setFont("helvetica", "bold");
      doc.setFontSize(11);
    } else {
      doc.setFont("helvetica", "normal");
      doc.setFontSize(11);
    }
    doc.setTextColor(0);

    const splitText = doc.splitTextToSize(item.text, contentWidth);
    const neededHeight = splitText.length * 5 + 3;
    const checkHeight =
      item.type === "h" || item.type === "h2"
        ? neededHeight + 15
        : neededHeight;

    y = checkPageBreak(y, checkHeight);
    doc.text(splitText, marginLeft, y);
    y += neededHeight;
  });

  // Tabella Valutazione Rischio
  const valutazioneRumoreData = [
    [
      "LEX,8h < 80 dB(A)",
      "Operaio Generico / Tecnico Specializzato",
      "TRASCURABILE",
    ],
    [
      "80 dB(A) < LEX,8h < 85 dB(A)",
      "Operaio Generico / Tecnico Specializzato",
      "BASSO",
    ],
  ];

  y = checkPageBreak(y, 30);

  autoTable(doc, {
    startY: y,
    head: [["Fascia di rischio", "Mansioni", "Valutazione del rischio"]],
    body: valutazioneRumoreData,
    theme: "grid",
    headStyles: { fillColor: borderColor, textColor: 255, fontStyle: "bold" },
    styles: { fontSize: 10, cellPadding: 3 },
    margin: { bottom: 25 },
  });

  y = doc.lastAutoTable.finalY + 15;

  // --- Valutazione Rischio Vibrazioni ---
  doc.addPage();
  addHeader(doc);
  y = 45;
  doc.setFontSize(16);
  doc.setTextColor(borderColor[0], borderColor[1], borderColor[2]);
  doc.text("Valutazione Rischio Vibrazioni", marginLeft, y);
  y += 10;

  const vibrazioniText = [
    {
      type: "p",
      text: "Si riporta una sintesi della valutazione del rischio da esposizione a vibrazioni meccaniche, effettuata ai sensi del Titolo VIII, Capo III, del D. Lgs. 81/08 e s.m.i., recepimento della Direttiva 2002/44/CE, tenendo conto delle specificità delle lavorazioni edili ed elettriche svolte in cantiere.",
    },
    {
      type: "p",
      text: "L’esposizione a vibrazioni meccaniche viene distinta in due tipologie: le vibrazioni trasmesse al sistema mano-braccio (HAV – Hand-Arm Vibrations) e le vibrazioni trasmesse al corpo intero (WBV – Whole-Body Vibrations). Per le attività tipiche del settore edile ed elettrico, le sorgenti principali di vibrazioni mano-braccio sono rappresentate da utensili portatili a motore quali trapani, tassellatori, martelli demolitori, flessibili, smerigliatrici angolari, pistole per fissaggi e avvitatori pneumatici. Le vibrazioni al corpo intero sono invece associate all’utilizzo di mezzi meccanici quali piastre vibranti, rulli compattatori, cariole motorizzate e veicoli da cantiere su fondi sconnessi.",
    },
    {
      type: "h2",
      text: "RIFERIMENTI ALLE NORME COGENTI E/O ALLE REGOLE DI BUONA TECNICA",
    },
    {
      type: "p",
      text: "D. Lgs. 81/08 – Titolo VIII – Capo III (artt. 199-205)",
    },
    {
      type: "p",
      text: "Come previsto dall’art. 202, comma 5, del D. Lgs. 81/08, il datore di lavoro può non effettuare la misurazione quando ritenga fondatamente che il livello di esposizione giornaliera A(8) di tutti i lavoratori non superi i valori di azione previsti per le vibrazioni mano-braccio e corpo intero.",
    },
    {
      type: "p",
      text: "Valori di azione e valori limite di esposizione giornaliera (normalizzati a 8 ore) previsti dalla normativa vigente:",
    },
    {
      type: "l",
      text: "• vibrazioni trasmesse al sistema mano-braccio: valore di azione A(8) = 2,5 m/s²; valore limite di esposizione A(8) = 5,0 m/s²;",
    },
    {
      type: "l",
      text: "• vibrazioni trasmesse al corpo intero: valore di azione A(8) = 0,5 m/s²; valore limite di esposizione A(8) = 1,15 m/s².",
    },
    { type: "h2", text: "CRITERI SPECIFICI DI VALUTAZIONE DEI RISCHI" },
    {
      type: "p",
      text: "La valutazione è stata condotta mediante l’analisi delle lavorazioni, delle attrezzature utilizzate e dei tempi di esposizione, facendo riferimento ai valori di emissione dichiarati dai costruttori delle macchine e, laddove disponibili, a banche dati e misure strumentali. In assenza di dati strumentali specifici, si è fatto ricorso a valutazioni semplificate basate sul tempo di utilizzo effettivo degli utensili vibranti durante la giornata lavorativa.",
    },
    { type: "h2", text: "Valutazione del rischio" },
    {
      type: "p",
      text: "Sulla base delle lavorazioni tipiche del cantiere, i lavoratori edili e gli elettricisti sono esposti in prevalenza a vibrazioni mano-braccio derivanti dall’uso di martelli demolitori, tassellatori, trapani e flessibili. L’esposizione giornaliera stimata, considerando i tempi di utilizzo effettivi e l’alternanza delle mansioni, si colloca generalmente al di sotto del valore di azione di 2,5 m/s² per i lavoratori adibiti ad attività elettriche (installazioni, tracce, forature di modesta entità). Per i lavoratori edili adibiti a demolizioni, scavi e compattazioni manuali, l’esposizione può avvicinarsi o superare il valore di azione in giornate caratterizzate da uso intensivo e prolungato di utensili vibranti; in tali casi il rischio è classificato come medio e sono attivate misure di riduzione. L’esposizione a vibrazioni al corpo intero è invece limitata a sporadici utilizzi di mezzi compattatori e veicoli da cantiere e si mantiene al di sotto del valore di azione di 0,5 m/s².",
    },
    { type: "h2", text: "MISURE DI PREVENZIONE E PROTEZIONE" },
    {
      type: "l",
      text: "• riduzione dei tempi di utilizzo continuato degli utensili vibranti tramite rotazione delle mansioni e pause tecniche;",
    },
    {
      type: "l",
      text: "• scelta di attrezzature a ridotta emissione vibrazionale e corretta manutenzione delle stesse;",
    },
    {
      type: "l",
      text: "• fornitura e utilizzo di DPI antivibrazione (guanti antivibranti certificati CE conformi alla EN ISO 10819) per tutti i lavoratori che utilizzano utensili vibranti;",
    },
    {
      type: "l",
      text: "• informazione e formazione dei lavoratori sui rischi connessi all’esposizione a vibrazioni e sulle corrette modalità di utilizzo degli utensili;",
    },
    {
      type: "l",
      text: "• sorveglianza sanitaria periodica per i lavoratori esposti, con particolare riguardo alle sindromi vascolari e neurologiche del sistema mano-braccio (sindrome di Raynaud, parestesie, ridotta sensibilità).",
    },
    {
      type: "p",
      text: "Si evidenzia che, in caso di superamento del valore di azione, il datore di lavoro provvede all’aggiornamento della valutazione dei rischi, alla definizione di un programma di misure tecniche e organizzative volte a ridurre l’esposizione, e alla sorveglianza sanitaria dei lavoratori interessati.",
    },
  ];

  vibrazioniText.forEach((item) => {
    if (item.type === "h") {
      doc.setFont("helvetica", "bold");
      doc.setFontSize(12);
    } else if (item.type === "h2") {
      doc.setFont("helvetica", "bold");
      doc.setFontSize(11);
    } else {
      doc.setFont("helvetica", "normal");
      doc.setFontSize(11);
    }
    doc.setTextColor(0);

    const splitText = doc.splitTextToSize(item.text, contentWidth);
    const neededHeight = splitText.length * 5 + 3;
    const checkHeight =
      item.type === "h" || item.type === "h2"
        ? neededHeight + 15
        : neededHeight;

    y = checkPageBreak(y, checkHeight);
    doc.text(splitText, marginLeft, y);
    y += neededHeight;
  });

  // Tabella Valutazione Rischio Vibrazioni
  const valutazioneVibrazioniData = [
    [
      "A(8) < 2,5 m/s² (mano-braccio)",
      "Elettricista / Operaio edile con uso sporadico di utensili vibranti",
      "TRASCURABILE",
    ],
    [
      "2,5 m/s² < A(8) < 5,0 m/s² (mano-braccio)",
      "Operaio edile adibito a demolizioni, scavi e compattazioni con uso intensivo di utensili vibranti",
      "MEDIO",
    ],
    [
      "A(8) < 0,5 m/s² (corpo intero)",
      "Tutti i lavoratori (uso sporadico di mezzi compattatori e veicoli da cantiere)",
      "TRASCURABILE",
    ],
  ];

  y = checkPageBreak(y, 40);

  autoTable(doc, {
    startY: y,
    head: [["Fascia di rischio", "Mansioni", "Valutazione del rischio"]],
    body: valutazioneVibrazioniData,
    theme: "grid",
    headStyles: { fillColor: borderColor, textColor: 255, fontStyle: "bold" },
    styles: { fontSize: 10, cellPadding: 3 },
    margin: { bottom: 25 },
  });

  y = doc.lastAutoTable.finalY + 15;

  // Tutela Minori
  doc.addPage();
  addHeader(doc);
  y = 45;
  doc.setFontSize(16);
  doc.setTextColor(borderColor[0], borderColor[1], borderColor[2]);
  doc.text("Tutela del Lavoro Minorile", marginLeft, y);
  y += 10;

  const minoriText = [
    { type: "p", text: "(L.977/67 e D.lgs. 345/1999)" },
    {
      type: "p",
      text: "Con “lavoro minorile” si intende il lavoro dei bambini e degli adolescenti di età compresa tra i 15 ed i 18 anni. La Legge 977/1967 stabilisce che il datore di lavoro, prima di adibire i minori al lavoro e in occasione del verificarsi di qualsivoglia modifica rilevante delle condizioni di lavoro, deve effettuare la specifica valutazione dei rischi, che integra quella già effettuata, avendo riguardo in particolare:",
    },
    {
      type: "l",
      text: "- allo sviluppo non completato, alla mancanza di esperienza e di consapevolezza nei riguardi dei rischi lavorativi, esistenti o possibili, in relazione all’età;",
    },
    {
      type: "l",
      text: "- alle attrezzature ed alla sistemazione del luogo e del posto di lavoro;",
    },
    {
      type: "l",
      text: "- alla natura, grado e durata di esposizione agli agenti chimici, fisici e biologici;",
    },
    { type: "l", text: "- alla movimentazione dei carichi;" },
    {
      type: "l",
      text: "- alla sistemazione, alla scelta, alla utilizzazione ed alla manipolazione delle attrezzature di lavoro, e, segnatamente degli agenti, macchine, apparecchi e strumenti;",
    },
    {
      type: "l",
      text: "- alla pianificazione dei processi di lavoro e dello svolgimento del lavoro e della loro interazione sull’organizzazione generale;",
    },
    {
      type: "l",
      text: "- alla situazione della formazione e dell’informazione dei minori.",
    },
    {
      type: "p",
      text: "Si evidenzia peraltro, nel caso in cui siano impiegati dei minori, l’obbligo per il datore di lavoro di fornire le informazioni sui rischi inerenti la mansione anche ai titolari della potestà genitoriale. Verrà vietato adibire gli adolescenti alle lavorazioni, ai processi ed ai lavori indicati nell’Allegato I della Legge 977/1967 aggiunto dal D. Lgs. 345/1999 e s.m.i.",
    },
    {
      type: "h",
      text: "AL MOMENTO NON È PREVISTO L’IMPIEGO DI LAVORATORI MINORENNI. SI PROCEDERA’ AD UNA REVISIONE DELLA PRESENTE VALUTAZIONE IN CASO DI NECESSITA’",
    },
  ];

  minoriText.forEach((item) => {
    if (item.type === "h") {
      doc.setFont("helvetica", "bold");
      doc.setFontSize(11);
    } else {
      doc.setFont("helvetica", "normal");
      doc.setFontSize(11);
    }
    doc.setTextColor(0);

    const splitText = doc.splitTextToSize(item.text, contentWidth);
    const neededHeight = splitText.length * 5 + 3;
    const checkHeight = item.type === "h" ? neededHeight + 15 : neededHeight;

    y = checkPageBreak(y, checkHeight);
    doc.text(splitText, marginLeft, y);
    y += neededHeight;
  });

  // --- Pagina 20: Organizzazione del Cantiere ---
  doc.addPage();
  addHeader(doc);
  y = 45;
  doc.setFontSize(16);
  doc.setTextColor(borderColor[0], borderColor[1], borderColor[2]);
  doc.text("Organizzazione del Cantiere", marginLeft, y);
  y += 10;

  const orgCantiereData = posData.OrganizzazioneCantiere || {};

  const orgCantiereText = [
    { type: "h2", text: "Descrizione del cantiere" },
    {
      type: "p",
      text:
        orgCantiereData.Descrizione ||
        "Il cantiere in esame è organizzato in modo razionale e nel rispetto delle norme vigenti, in conformità alla tipologia del cantiere stesso e in modo da garantire un ambiente di lavoro tecnicamente sicuro e igienico.",
    },
    {
      type: "p",
      text: "E’ parte integrante del presente documento la planimetria relativa all’impianto di cantiere in oggetto, nelle quali è riportata:",
    },
    { type: "l", text: "- delimitazione delle aree di cantiere" },
    { type: "l", text: "- la posizione del cartello di cantiere" },
    { type: "l", text: "- la collocazione degli accessi al cantiere" },
    {
      type: "l",
      text: "- la collocazione delle aree di deposito per i materiali",
    },
    {
      type: "l",
      text: "- la collocazione estintori e della cassetta di pronto soccorso",
    },

    { type: "h2", text: "Recinzione di cantiere" },
    {
      type: "p",
      text:
        orgCantiereData.Recinzione ||
        "Le aree di cantiere risultano principalmente confinate all’interno di ambienti chiusi distribuiti ai vari piani dell’edificio. Nel caso di serramenti situati in locali con passaggio di persone, come ad esempio i corridoi / disimpegni o i pianerottoli delle scale, verranno posizionate apposite delimitazioni con bandelle colorate ed apposta opportuna cartellonistica di divieto / indicazione percorsi alternativi, oppure, nel caso di corridoi o altri spazi ampi, verrà delimitata solo la porzione di locale attigua al serramento per permettere il transito delle persone nella restante parte di locale. Il cartello di cantiere deve avere dimensioni minime di m 1 di larghezza e di m 2 di altezza, deve essere collocato in sito ben visibile entro cinque giorni dalla consegna dei lavori.",
    },

    { type: "h2", text: "Accessi (ai pedoni ed ai mezzi) e segnalazioni" },
    {
      type: "p",
      text:
        orgCantiereData.Accessi ||
        "L'accesso alle aree di cantiere sarà consentito solo al personale autorizzato e avverrà dall’ingresso del cantiere. Ogni locale oggetto di intervento sul serramento sarà vuoto e la porta di accesso chiusa e con presenza di cartello di divieto di accesso. Gli automezzi delle imprese potranno sostare per il tempo necessario alle attività di carico / scarico materiali e attrezzature nel parcheggio del cantiere.",
    },

    { type: "h2", text: "Viabilità del cantiere" },
    {
      type: "p",
      text:
        orgCantiereData.Viabilita ||
        "Il tipo di cantiere in esame non prevede viabilità interna di mezzi meccanici.",
    },

    { type: "h2", text: "Aree di deposito per i materiali" },
    {
      type: "p",
      text:
        orgCantiereData.AreeDeposito ||
        "Nel cantiere sono previste delle zone di stoccaggio materiale debitamente segnalate. L’individuazione è subordinata ai percorsi, alla natura ed eventuale pericolosità dei materiali. Dovranno essere debitamente segnalati e protetti. Lo stoccaggio del materiale verrà effettuato in zone segnalate e delimitate, in modo razionale e tale da non creare ostacoli.",
    },

    { type: "h2", text: "Deposito rifiuti e procedure di smaltimento" },
    {
      type: "p",
      text:
        orgCantiereData.Rifiuti ||
        "Il deposito dei rifiuti sarà effettuato servendosi di idonei contenitori, differenziati per tipologia di rifiuto, che verranno posizionati in luoghi tali da evitare il fastidio provocato da eventuali emanazioni insalubri e nocive; ad intervalli regolari si provvederà a consegnare gli stessi a ditta specializzata che li porterà nei punti di raccolta autorizzati.",
    },

    { type: "h2", text: "Servizi fissi di cantiere" },
    { type: "h3", text: "Servizi igienici" },
    {
      type: "p",
      text:
        orgCantiereData.ServiziIgienici ||
        "Nei cantieri potranno essere utilizzati dagli operai i servizi igienici esistenti al piano interrato del corpo di fabbrica di Via Verdi (corridoio di sinistra dopo l’ingresso da Largo De Sabata); i locali dovranno essere mantenuti puliti dopo l’utilizzo.",
    },
    { type: "h3", text: "Mensa e locale di riposo" },
    {
      type: "p",
      text:
        orgCantiereData.Mensa ||
        "Verrà stipulata una convenzione con il bar più vicino.",
    },
    { type: "h3", text: "Servizi sanitari" },
    {
      type: "p",
      text:
        orgCantiereData.ServiziSanitari ||
        "In cantiere, in prossimità delle zone interessate dai lavori, vanno tenuti i presidi sanitari (cassetta di pronto soccorso o pacchetto di medicazione) indispensabili per poter prestare le prime ed immediate cure ai lavoratori feriti o colpiti da improvviso malessere. La collocazione dei servizi per il primo pronto soccorso sarà resa nota ai lavoratori e segnalata in modo visibile con appositi cartelli. (vedi tavola allegata)",
    },
    { type: "h3", text: "Uffici" },
    {
      type: "p",
      text:
        orgCantiereData.Uffici ||
        "In cantiere verrà adibito uno spazio ad uso ufficio (collocazione come da tavola allegata).",
    },

    { type: "h2", text: "Impianti Elettrici" },
    {
      type: "p",
      text:
        orgCantiereData.ImpiantiElettrici ||
        "l’impianto elettrico verrà realizzato all’interno del cantiere, utilizzando un allaccio esistente, fornito dalla committenza. Devono corrispondere a quanto previsto dalla L. 37/08 e dalle norme CEI di buona tecnica. Il dimensionamento dell’impianto e la sua esecuzione, in rapporto ai macchinari previsti, sono a completo carico dell’impresa. Tutti i componenti dell’impianto elettrico devono avere grado di protezione minimo IP43, ad eccezione delle prese a spina di tipo mobile (volanti), che devono avere grado di protezione IP67 (protette contro l’immersione) e degli apparecchi illuminanti , che devono avere un grado di protezione IP55. Le prese a spina devono essere del tipo protetto da interruttore differenziale con corrente differenziale non superiore a 30 mA. ( CEI 64.8/7 art. 704.471 e CEI 17.13/4 art. 9.5.2 ). Nei quadri elettrici dovrà essere prevista almeno una protezione magnetotermica ogni 6 prese. Ad evitare che il circuito sia richiuso intempestivamente durante l’esecuzione di lavori elettrici o per manutenzione apparecchi e impianti, gli interruttori generali di quadro saranno del tipo bloccabili in posizione di aperto o alloggiati entro quadri con chiusura a chiave ( CEI 64.8/ 4 art. 462.2 e CEI 64.8/7 art. 704 537 ) Tutti i quadri saranno dotati di un dispositivo di interruzione generale di emergenza. Per le linee si dovranno utilizzare cavi del tipo: N1VV-K o FG7R o FG7OR per la posa fissa e interrata; H07RN-F o FG1K 450/750 V o FG10K 450/750 v per posa mobile.",
    },
    {
      type: "p",
      text: "Misura protettiva importante è l'impianto elettrico di terra da integrarsi con un dispositivo di interruzione automatica della corrente di tipo differenziale (salvavita); detto impianto è utile anche per la dispersione delle scariche atmosferiche che possono colpire gli elementi metallici all'aperto, si rende quindi necessario collegare ad esso le grandi masse metalliche.",
    },

    { type: "h2", text: "Impianto di messa a terra (sistemi TT)" },
    {
      type: "p",
      text: "L’impianto di terra dovrà essere eseguito all’atto dell’installazione degli apparecchi elettrici di cantiere ed avrà lo scopo di fornire lo stesso potenziale di terra a tutte le masse presenti.",
    },
    {
      type: "p",
      text: "L’impianto di terra sarà costituito da: -dispersori; -nodo (o collettore) principale di terra; -conduttori di protezione ; -conduttori equipotenziali principali.",
    },
    {
      type: "p",
      text: "In particolare il ponteggio dovrà essere dotato di un proprio sistema di dispersori e successivamente collegato all’impianto di terra con un conduttore di rame di sezione adeguata. L’impianto di terra del cantiere sarà completato collegandolo all’impianto di terra già esistente del fabbricato.",
    },

    { type: "h2", text: "Antincendio" },
    {
      type: "p",
      text: "Vedi disposizioni particolari nel capitolo “prevenzione incendi”.",
    },
  ];

  orgCantiereText.forEach((item) => {
    if (item.type === "h2") {
      doc.setFont("helvetica", "bold");
      doc.setFontSize(12);
    } else if (item.type === "h3") {
      doc.setFont("helvetica", "bold");
      doc.setFontSize(11);
    } else {
      doc.setFont("helvetica", "normal");
      doc.setFontSize(11);
    }
    doc.setTextColor(0);

    const splitText = doc.splitTextToSize(item.text, contentWidth);
    const neededHeight = splitText.length * 5 + 3;
    const checkHeight =
      item.type === "h2" || item.type === "h3"
        ? neededHeight + 15
        : neededHeight;

    y = checkPageBreak(y, checkHeight);
    doc.text(splitText, marginLeft, y);
    y += neededHeight;
  });

  // --- Analisi Fasi di Lavoro ---
  doc.addPage();
  addHeader(doc);
  y = 45;
  doc.setFontSize(16);
  doc.setTextColor(borderColor[0], borderColor[1], borderColor[2]);
  doc.text("Analisi Fasi di Lavoro", marginLeft, y);
  y += 10;

  // Legenda matrice di valutazione del rischio (R = P × D)
  doc.setFont("helvetica", "normal");
  doc.setFontSize(11);
  doc.setTextColor(0);
  const legendaRischioText = doc.splitTextToSize(
    "Per ciascuna fase operativa la stima del rischio è determinata secondo la matrice Probabilità (P) × Gravità del danno (D) adottata ai sensi del D. Lgs. 81/08. L’indice di rischio R = P × D, con P e D compresi tra 1 e 4, individua il livello di rischio come di seguito riportato.",
    contentWidth,
  );
  y = checkPageBreak(y, legendaRischioText.length * 5 + 5);
  doc.text(legendaRischioText, marginLeft, y);
  y += legendaRischioText.length * 5 + 3;

  y = checkPageBreak(y, 34);
  autoTable(doc, {
    startY: y,
    head: [
      [
        "Probabilità (P)",
        "Gravità del danno (D)",
        "Indice R = P × D",
        "Livello di rischio",
      ],
    ],
    body: [
      ["1 – Improbabile", "1 – Lieve", "1 – 2", "Trascurabile"],
      ["2 – Poco probabile", "2 – Modesta", "3 – 4", "Basso"],
      ["3 – Probabile", "3 – Grave", "5 – 8", "Medio"],
      ["4 – Molto probabile", "4 – Gravissima", "9 – 16", "Alto"],
    ],
    theme: "grid",
    headStyles: { fillColor: borderColor, textColor: 255, fontStyle: "bold" },
    styles: { fontSize: 9, cellPadding: 2.5 },
    margin: { left: marginLeft, right: marginRight, bottom: 25 },
  });
  y = doc.lastAutoTable.finalY + 10;

  const rischi = posData.ValutazioneRischi || [];

  if (Array.isArray(rischi) && rischi.length > 0) {
    rischi.forEach((fase, index) => {
      if (index > 0) {
        doc.addPage();
        addHeader(doc);
        y = 45;
      }

      // Fase Header
      doc.setFont("helvetica", "bold");
      doc.setFontSize(14);
      doc.setTextColor(borderColor[0], borderColor[1], borderColor[2]); // Uso colore rosso per le fasi

      // Check page break for Phase Title
      const faseTitle = `Fase ${index + 1}: ${fase.fase || "Generica"}`;
      const splitFaseTitle = doc.splitTextToSize(faseTitle, contentWidth);
      const faseTitleHeight = splitFaseTitle.length * 6; // Approx height for font size 14

      doc.text(splitFaseTitle, marginLeft, y);
      y += faseTitleHeight + 2;

      // Stima del rischio della fase (matrice P × D)
      let indiceRischio = computeIndiceRischio(fase.probabilita, fase.danno);
      if (indiceRischio == null && fase.indiceRischio != null) {
        const stored = Number(fase.indiceRischio);
        if (Number.isFinite(stored)) indiceRischio = stored;
      }
      const { livello, color } = classifyRischio(indiceRischio);
      const probabilitaLabel = `${Number(fase.probabilita)}`;
      const dannoLabel = `${Number(fase.danno)}`;

      doc.setFont("helvetica", "bold");
      doc.setFontSize(11);
      doc.setTextColor(0);
      y = checkPageBreak(y, 12);
      doc.text("Stima del Rischio (matrice P × D)", marginLeft, y);
      y += 5;

      y = checkPageBreak(y, 20);
      autoTable(doc, {
        startY: y,
        head: [
          [
            "Probabilità (P)",
            "Gravità (D)",
            "Indice (P × D)",
            "Livello di rischio",
          ],
        ],
        body: [
          [
            indiceRischio != null ? probabilitaLabel : "N.D.",
            indiceRischio != null ? dannoLabel : "N.D.",
            indiceRischio != null ? String(indiceRischio) : "N.D.",
            livello,
          ],
        ],
        theme: "grid",
        headStyles: {
          fillColor: borderColor,
          textColor: 255,
          fontStyle: "bold",
        },
        styles: { fontSize: 10, cellPadding: 3, halign: "center" },
        didParseCell: (data) => {
          if (data.section === "body" && data.column.index === 3) {
            data.cell.styles.fillColor = color;
            data.cell.styles.textColor = 255;
            data.cell.styles.fontStyle = "bold";
          }
        },
        margin: { left: marginLeft, right: marginRight, bottom: 25 },
      });
      y = doc.lastAutoTable.finalY + 6;

      const sections = [
        { title: "Rischi", content: fase.rischi },
        { title: "Misure di Prevenzione", content: fase.prevenzione },
        { title: "DPI", content: fase.dpi },
        { title: "Procedure Operative Standard", content: fase.procedure },
        { title: "Interferenze e Coordinamento", content: fase.interferenze },
      ];

      sections.forEach((sec) => {
        // Section Title
        doc.setFont("helvetica", "bold");
        doc.setFontSize(11);
        doc.setTextColor(0); // Nero per sottotitoli

        y = checkPageBreak(y, 10);
        doc.text(sec.title, marginLeft, y);
        y += 5;

        // Section Content
        doc.setFont("helvetica", "normal");
        doc.setFontSize(11);

        // Handle content if it's an array (fallback) or string
        let textContent = sec.content || "Nessun dato disponibile.";
        if (Array.isArray(textContent)) {
          textContent = textContent.join("\n");
        }

        const splitText = doc.splitTextToSize(textContent, contentWidth);
        const neededHeight = splitText.length * 5 + 5;

        y = checkPageBreak(y, neededHeight);
        doc.text(splitText, marginLeft, y);
        y += neededHeight;
      });

      y += 10; // Spacing between phases
    });
  } else {
    doc.setFontSize(11);
    doc.setTextColor(0);
    doc.text(
      "Nessuna valutazione rischi presente. Generare nuovamente il POS con l'AI.",
      marginLeft,
      y,
    );
  }

  // --- ALLEGATO: SCHEDA INFORTUNIO ---
  doc.addPage();
  // Non aggiungiamo header standard, usiamo header specifico
  y = 20;

  // Titolo Scheda
  doc.setFillColor(200, 200, 200);
  doc.rect(marginLeft, y, contentWidth, 10, "F");
  doc.rect(marginLeft, y, contentWidth, 10, "S");
  doc.setFont("helvetica", "bold");
  doc.setFontSize(14);
  doc.setTextColor(0);
  doc.text("SCHEDA RILEVAZIONE INFORTUNIO / INCIDENTE", pageWidth / 2, y + 7, {
    align: "center",
  });
  y += 15;

  // 1. TIPO DI EVENTO
  doc.setFontSize(10);
  doc.text("TIPO DI EVENTO:", marginLeft, y);
  y += 5;

  autoTable(doc, {
    startY: y,
    body: [
      [
        "[  ] INFORTUNIO (con lesione)",
        "[  ] INCIDENTE (danni materiali)",
        "[  ] MANCATO INFORTUNIO (near miss)",
      ],
    ],
    theme: "grid",
    styles: { fontSize: 10, cellPadding: 3, halign: "center" },
    columnStyles: {
      0: { cellWidth: contentWidth / 3 },
      1: { cellWidth: contentWidth / 3 },
      2: { cellWidth: contentWidth / 3 },
    },
    margin: { left: marginLeft, right: marginRight },
  });
  y = doc.lastAutoTable.finalY + 5;

  // 2. DATI EVENTO
  autoTable(doc, {
    startY: y,
    head: [
      [
        {
          content: "DATI DELL'EVENTO",
          colSpan: 4,
          styles: {
            fillColor: [220, 220, 220],
            textColor: 0,
            fontStyle: "bold",
          },
        },
      ],
    ],
    body: [
      [
        "Data evento:",
        "__________________",
        "Ora evento:",
        "__________________",
      ],
      [
        "Luogo esatto:",
        {
          content: "__________________________________________________________",
          colSpan: 3,
        },
      ],
      [
        "Attività svolta:",
        {
          content: "__________________________________________________________",
          colSpan: 3,
        },
      ],
    ],
    theme: "grid",
    styles: { fontSize: 10, cellPadding: 3 },
    columnStyles: { 0: { cellWidth: 30 }, 2: { cellWidth: 30 } },
    margin: { left: marginLeft, right: marginRight },
  });
  y = doc.lastAutoTable.finalY + 5;

  // 3. PERSONA COINVOLTA
  autoTable(doc, {
    startY: y,
    head: [
      [
        {
          content: "PERSONA COINVOLTA",
          colSpan: 4,
          styles: {
            fillColor: [220, 220, 220],
            textColor: 0,
            fontStyle: "bold",
          },
        },
      ],
    ],
    body: [
      [
        "Cognome e Nome:",
        {
          content: "__________________________________________________________",
          colSpan: 3,
        },
      ],
      [
        "Mansione:",
        "__________________",
        "Anzianità nella mansione:",
        "__________________",
      ],
      [
        "Dipendente di:",
        "[  ] Azienda scrivente",
        "[  ] Ditta appaltatrice:",
        "__________________",
      ],
    ],
    theme: "grid",
    styles: { fontSize: 10, cellPadding: 3 },
    columnStyles: { 0: { cellWidth: 35 } },
    margin: { left: marginLeft, right: marginRight },
  });
  y = doc.lastAutoTable.finalY + 5;

  // 4. DESCRIZIONE DINAMICA
  autoTable(doc, {
    startY: y,
    head: [
      [
        {
          content:
            "DESCRIZIONE DETTAGLIATA DELL'ACCADUTO (Cosa è successo, come, con quali attrezzature)",
          styles: {
            fillColor: [220, 220, 220],
            textColor: 0,
            fontStyle: "bold",
          },
        },
      ],
    ],
    body: [[{ content: "\n\n\n\n\n\n", styles: { minCellHeight: 40 } }]],
    theme: "grid",
    margin: { left: marginLeft, right: marginRight },
  });
  y = doc.lastAutoTable.finalY + 5;

  // 5. CAUSE IMMEDIATE E CONCAUSE
  autoTable(doc, {
    startY: y,
    head: [
      [
        {
          content: "ANALISI DELLE CAUSE (Barrare le voci pertinenti)",
          colSpan: 2,
          styles: {
            fillColor: [220, 220, 220],
            textColor: 0,
            fontStyle: "bold",
          },
        },
      ],
    ],
    body: [
      [
        { content: "FATTORE UMANO / COMPORTAMENTALE", fontStyle: "bold" },
        { content: "FATTORE AMBIENTALE / TECNICO", fontStyle: "bold" },
      ],
      ["[  ] Mancato uso DPI", "[  ] Pavimento scivoloso / sconnesso"],
      [
        "[  ] Uso errato attrezzatura",
        "[  ] Illuminazione scarsa / inadeguata",
      ],
      ["[  ] Mancato rispetto procedure", "[  ] Spazio di lavoro ristretto"],
      [
        "[  ] Distrazione / Fretta",
        "[  ] Attrezzatura difettosa / priva di protezioni",
      ],
      [
        "[  ] Valutazione errata del rischio",
        "[  ] Segnaletica assente / carente",
      ],
      [
        "[  ] Altro: _______________________",
        "[  ] Altro: _______________________",
      ],
    ],
    theme: "grid",
    styles: { fontSize: 9, cellPadding: 2 },
    margin: { left: marginLeft, right: marginRight },
  });
  y = doc.lastAutoTable.finalY + 5;

  // 6. CONSEGUENZE
  doc.addPage();
  addHeader(doc);
  y = 45;
  autoTable(doc, {
    startY: y,
    head: [
      [
        {
          content: "CONSEGUENZE (Solo per infortuni)",
          colSpan: 2,
          styles: {
            fillColor: [220, 220, 220],
            textColor: 0,
            fontStyle: "bold",
          },
        },
      ],
    ],
    body: [
      [
        "Parte del corpo lesa:",
        "________________________________________________________",
      ],
      [
        "Natura della lesione:",
        "________________________________________________________",
      ],
      ["Prognosi (giorni stimati):", "__________________"],
    ],
    theme: "grid",
    styles: { fontSize: 10, cellPadding: 3 },
    margin: { left: marginLeft, right: marginRight },
  });
  y = doc.lastAutoTable.finalY + 5;

  // 7. EVENTUALI TESTIMONI
  autoTable(doc, {
    startY: y,
    head: [
      [
        {
          content: "TESTIMONI",
          styles: {
            fillColor: [220, 220, 220],
            textColor: 0,
            fontStyle: "bold",
          },
        },
      ],
    ],
    body: [
      [
        "1. Cognome e Nome: ___________________________________  Firma: ________________________",
      ],
      [
        "2. Cognome e Nome: ___________________________________  Firma: ________________________",
      ],
    ],
    theme: "grid",
    styles: { fontSize: 10, cellPadding: 3 },
    margin: { left: marginLeft, right: marginRight },
  });
  y = doc.lastAutoTable.finalY + 10;

  // FIRME
  doc.setFontSize(10);
  doc.text("Data compilazione: __________________", marginLeft, y);
  y += 15;

  const signY = y;
  doc.text("Firma del Compilatore", marginLeft, signY);
  doc.text("Firma del RLS (per presa visione)", pageWidth / 2 - 20, signY);
  doc.text("Firma del Datore di Lavoro", pageWidth - marginRight - 40, signY);

  doc.line(marginLeft, signY + 10, marginLeft + 40, signY + 10);
  doc.line(pageWidth / 2 - 20, signY + 10, pageWidth / 2 + 20, signY + 10);
  doc.line(
    pageWidth - marginRight - 40,
    signY + 10,
    pageWidth - marginRight,
    signY + 10,
  );

  // --- ALLEGATO: DICHIARAZIONE CONFORMITA' ATTREZZATURE ---
  doc.addPage();
  addHeader(doc);
  y = 45;

  doc.setFontSize(14);
  doc.setFont("helvetica", "bold");
  doc.setTextColor(borderColor[0], borderColor[1], borderColor[2]);
  doc.text("DICHIARAZIONE DI CONFORMITÀ ATTREZZATURE", marginLeft, y);
  y += 10;

  doc.setFontSize(10);
  doc.setTextColor(0);
  doc.setFont("helvetica", "normal");

  const dichiarazioneText = [
    {
      type: "p",
      text: "Io sottoscritto ROBERTO FERRI nato a CERNUSCO S/N il 10/11/1977 residente a INZAGO VIA COLLODI 28, in qualità di amministratore unico della ditta GIUVI SRL con sede legale MILANO VIA BELGIRATE,15 Cod.Fisc./P.IVA 07873720960",
    },
    { type: "h_center", text: "DICHIARO" },
    {
      type: "p",
      text: "- Che le nostre attrezzature sono conformi alle disposizioni legislative e regolamentari che riguardano i requisiti di sicurezza del D.lgs. 81/08 – Titolo III – Capo III, il DM 22/01/2008 n°37 e il DPR 462/01, conformi alle norme tecniche del CEI - Comitato Elettrotecnico Italiano - fra cui la norma 64-8, e DPR 547/55 – DPR 459/96",
    },
    { type: "li", text: "Utensili manuali" },
    { type: "li", text: "Utensili elettrici portatili" },
    { type: "li", text: "Trapano elettrico e a batteria" },
    { type: "li", text: "Scale a mano" },
    { type: "li", text: "Avvitatori a batteria" },
    {
      type: "p",
      text: "- Con la dotazione delle stesse, secondo quanto previsto dal D.lgs. 81/08 art.36, abbiamo provveduto a fornire ai lavoratori informazioni riguardo i rischi per la sicurezza e la salute connessi all'attività dell'impresa in generale, i rischi specifici cui sono esposti in relazione all'attività svolta, le normative di sicurezza e le disposizioni aziendali in materia, i pericoli connessi all'uso delle sostanze e dei preparati pericolosi sulla base delle schede dei dati di sicurezza previste dalla normativa vigente e dalle norme di buona tecnica, formazione specifica sull’utilizzo dell’attrezzatura",
    },
    {
      type: "p",
      text: "- Che il personale impiegato presso il cantiere sopracitato, è idoneo dal punto di vista sanitario così come previsto dal ex D.lgs. 81/08",
    },
  ];

  dichiarazioneText.forEach((item) => {
    if (item.type === "h_center") {
      doc.setFont("helvetica", "bold");
      doc.setFontSize(12);
      const textWidth = doc.getTextWidth(item.text);
      doc.text(item.text, (pageWidth - textWidth) / 2, y);
      y += 10;
    } else if (item.type === "l_arrow") {
      doc.setFont("helvetica", "normal");
      doc.setFontSize(10);
      // Using a simple arrow or bullet character
      doc.text(`   ➢ ${item.text}`, marginLeft + 5, y);
      y += 6;
    } else {
      doc.setFont("helvetica", "normal");
      doc.setFontSize(10);
      const splitText = doc.splitTextToSize(item.text, contentWidth);
      doc.text(splitText, marginLeft, y);
      y += splitText.length * 5 + 5;
    }
  });

  y += 20;
  doc.text("Firma del Dichiarante", pageWidth - marginRight - 50, y);
  doc.line(
    pageWidth - marginRight - 50,
    y + 10,
    pageWidth - marginRight,
    y + 10,
  );

  // --- ALLEGATO: INFORMAZIONE DEI LAVORATORI E GESTIONE DELLE EMERGENZE ---
  doc.addPage();
  addHeader(doc);
  y = 45;

  doc.setFontSize(14);
  doc.setFont("helvetica", "bold");
  doc.setTextColor(borderColor[0], borderColor[1], borderColor[2]);
  doc.text(
    "INFORMAZIONE DEI LAVORATORI E GESTIONE DELLE EMERGENZE",
    marginLeft,
    y,
  );
  y += 10;

  doc.setFontSize(10);
  doc.setTextColor(0);
  doc.setFont("helvetica", "normal");

  const infoLavoratoriText = [
    {
      type: "p",
      text: "Il personale operante nel cantiere, sottoscrivendo il presente documento prende visione delle disposizioni in esso previste e si impegna a:",
    },
    {
      type: "li",
      text: "rispettare scrupolosamente le vigenti normative in materia di prevenzione infortuni ed igiene del lavoro e a porre particolare attenzione ai rischi valutati dal Datore di Lavoro",
    },
    {
      type: "li",
      text: "seguire negli spostamenti i percorsi stabiliti, evitando di ingombrarli con materiali o attrezzature",
    },
    {
      type: "li",
      text: "non lasciare attrezzature e/o materiali potenzialmente fonte pericolo in luoghi di transito",
    },
    {
      type: "li",
      text: "non abbandonare attrezzi e/o materiali in posizione di equilibrio instabile o, qualora ciò sia indispensabile, segnalarne la presenza avvertendo tempestivamente la direzione del cantiere per gli altri provvedimenti del caso",
    },
    {
      type: "li",
      text: "non usare abusivamente attrezzature e/o materiali non di propria proprietà",
    },
    { type: "li", text: "rispettare la segnaletica di sicurezza" },
    {
      type: "li",
      text: "utilizzare costantemente i DPI che si rendono necessari in base ai rischi presenti",
    },
    {
      type: "li",
      text: "non rimuovere o modificare di propria iniziativa i dispositivi di sicurezza, segnalazione e controllo predisposti in cantiere",
    },
    {
      type: "li",
      text: "non compiere di propria iniziativa operazioni o manovre che non siano di competenza o che possano compromettere la sicurezza di altre persone presenti nel cantiere",
    },
    {
      type: "li",
      text: "segnalare immediatamente al proprio Responsabile Tecnico nel cantiere eventuali condizioni di pericolo di cui venga a conoscenza",
    },
    {
      type: "li",
      text: "non accendere fuochi all’interno dell’area del cantiere",
    },
    {
      type: "li",
      text: "rendere operative le disposizioni di primo soccorso e gestione di emergenze ed infortuni",
    },
    {
      type: "p",
      text: "Ogni variazione delle condizioni riportate nella presente scheda dovranno essere immediatamente comunicate all’impresa scrivente per le valutazioni di competenza.",
    },
    { type: "gap", height: 10 },
    { type: "p", text: "Timbro dell’Impresa" },
    { type: "gap", height: 20 },
    { type: "line" },
    {
      type: "p",
      text: "In caso di inadempienze di uno o più dei punti elencati, la scrivente impresa si impegna, in tempi brevi, al loro corretto espletamento",
    },
  ];

  infoLavoratoriText.forEach((item) => {
    y = checkPageBreak(y, 20); // Check enough space for at least a few lines
    if (item.type === "p") {
      const splitText = doc.splitTextToSize(item.text, contentWidth);
      doc.text(splitText, marginLeft, y);
      y += splitText.length * 5 + 5;
    } else if (item.type === "li") {
      const splitText = doc.splitTextToSize(item.text, contentWidth - 5);
      doc.text("-", marginLeft, y);
      doc.text(splitText, marginLeft + 5, y);
      y += splitText.length * 5 + 3;
    } else if (item.type === "gap") {
      y += item.height;
    } else if (item.type === "line") {
      doc.setLineWidth(0.5);
      doc.line(marginLeft, y, pageWidth - marginRight, y);
      y += 10;
    }
  });

  // Aggiunta Footer su tutte le pagine
  const pageCount = doc.getNumberOfPages();
  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);
    doc.setFontSize(8);
    doc.setTextColor(100);

    const footerYStart = pageHeight - 18;
    const centerX = pageWidth / 2;

    // Riga 1: Dati principali
    doc.text(
      "GIUVI SRL - Via Belgirate, 15 - 20125 Milano (MI) - Tel. 02/97190315",
      centerX,
      footerYStart,
      { align: "center" },
    );

    // Riga 2: Dati fiscali e contatti
    doc.text(
      "Cap.Soc. € 10.000,00 - PI/CF/Nr.Reg.Impr.MI IT07873720960 - REA MI-2010873 - info@giuvi.it",
      centerX,
      footerYStart + 4,
      { align: "center" },
    );

    // Riga 3: Numerazione Pagina
    const pageText = `Pagina ${i} di ${pageCount}`;
    doc.text(pageText, pageWidth - marginRight, pageHeight - 10, {
      align: "right",
    });
  }

  // Salva il file
  const safeName = fileName
    ? fileName.replace(/[^a-z0-9]/gi, "_").toLowerCase()
    : "pos_generato";
  doc.save(`${safeName}.pdf`);
}
